var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPathwayCleaner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 1920 960",
    enableBackground: "new 0 0 1920 960",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "line-3",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1191.500000,164.500000   C1191.598633,158.140945 1186.893921,154.331421 1183.434204,150.053177   C1165.584595,127.980461 1142.902344,112.178909 1117.501465,99.996902   C1098.040161,90.663490 1077.715576,84.126122 1056.522461,79.887428   C1036.832275,75.949333 1016.987366,73.937767 997.001587,74.149284   C980.250977,74.326561 963.582214,76.087029 946.973694,78.841263   C927.408203,82.085854 908.191406,86.539963 889.528442,93.081093   C858.333252,104.014580 829.475891,119.290123 803.429016,139.910294   C784.710449,154.728958 768.322205,171.575165 754.432922,190.951920   C752.804626,193.223495 752.115723,195.366394 752.500000,198.000000  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "line-4",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1286.000000,602.500000   C1290.525269,607.487305 1290.212646,614.053467 1291.395752,620.020691   C1293.898438,632.643433 1295.463623,645.456665 1299.498535,657.750488   C1300.492432,660.778687 1301.898193,663.519409 1303.911011,666.070190   C1305.150879,667.641479 1306.087646,669.445618 1304.608032,672.061096   C1297.965454,683.803711 1292.610474,696.216064 1286.059692,708.033081   C1270.746826,735.655762 1253.279419,761.790894 1232.963989,785.969727   C1220.637329,800.640503 1207.126587,814.175781 1191.984009,825.979492   C1180.403564,835.006531 1168.048706,842.687317 1153.494629,845.976257   C1136.005005,849.928528 1120.660156,845.979309 1107.468140,833.533813   C1092.540649,819.451172 1085.094116,801.717773 1081.517700,781.996765   C1080.403076,775.850891 1079.282715,769.690430 1078.604736,763.488525   C1078.325562,760.934692 1077.301636,758.986572 1076.000000,757.000000  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "line-5",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M572.000000,679.500000   C566.361389,690.087646 562.332092,701.367737 558.055481,712.521240   C551.625732,729.290222 546.367554,746.442322 542.500183,764.000061   C538.689087,781.301819 536.070312,798.784851 538.106873,816.487732   C540.281189,835.388062 547.515991,851.395996 567.023987,858.433594   C576.676147,861.915649 586.841553,862.429504 596.994751,861.445679   C605.428955,860.628479 613.817322,859.339294 622.000916,857.003296   C623.828125,856.481689 626.309998,856.578979 627.378967,855.391113   C630.540588,851.877808 634.463135,852.011597 638.500000,851.997375   C641.904663,851.985352 645.312073,852.179077 648.526550,850.552429   C649.522522,850.048401 651.041260,849.680481 651.967224,850.076599   C659.625183,853.352417 666.764954,849.951599 673.991211,848.457642   C702.630798,842.536499 728.160583,829.321655 753.015747,814.526428   C760.730164,809.934448 767.441956,803.740479 775.955200,800.386292   C777.275757,799.866089 778.000549,797.833740 779.044678,796.442261   C775.782715,791.431763 780.736206,786.099915 778.500000,781.000000  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "line-6",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M733.500000,220.500000   C728.646240,217.816315 724.175476,220.688538 720.056274,222.157700   C696.530212,230.548584 674.424927,241.582306 654.414978,256.888855   C632.154297,273.917114 613.740356,294.144287 600.075012,318.541992   C591.561096,333.742493 585.643372,349.974426 584.017639,367.501648   C582.781860,380.823090 582.903137,394.081573 587.060852,406.980408   C587.640015,408.777252 588.287170,410.761047 590.000000,412.000000  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "line-7",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M776.500000,801.000000   C778.774353,806.166992 777.273315,811.674500 777.876587,817.013916   C780.184692,837.445007 786.116272,856.242798 799.971497,872.025024   C811.497803,885.154297 826.280701,889.547974 842.990479,887.903503   C862.652893,885.968323 879.629333,876.875549 896.004395,866.506897   C913.874268,855.191711 929.573792,841.364807 943.463135,825.467773   C945.950439,822.621033 946.482483,818.199646 950.987305,816.954102   C957.570312,815.133911 963.871521,812.421692 971.006592,812.901611   C976.289917,813.256836 981.068909,810.573853 985.995483,808.986023   C1016.464172,799.165527 1043.528076,783.062927 1069.048828,764.065613   C1071.457031,762.272888 1072.300903,760.187622 1072.500000,757.500000  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "line-8",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1272.000000,620.500000   C1275.497437,626.803528 1271.345703,632.294739 1269.296387,637.418579   C1257.353394,667.280151 1241.929077,695.316956 1222.429077,720.946045   C1213.010498,733.325012 1202.940308,745.237549 1188.999512,752.999146   C1184.950928,755.253174 1180.846436,757.192688 1175.998901,757.032166   C1169.859497,756.828857 1166.190796,753.171265 1165.978394,747.000732   C1165.671631,738.090820 1169.419556,730.179871 1172.073364,722.023865   C1173.311523,718.217773 1175.214478,714.605957 1177.044678,711.022827   C1178.136475,708.885803 1178.215698,706.673828 1177.926270,704.509888   C1177.622314,702.237549 1177.919067,700.134827 1178.500000,698.000000  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "line-9",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M594.500000,691.000000   C587.842407,704.614502 580.709229,717.952271 575.864197,732.454651   C568.610596,754.166382 565.505005,776.095032 571.110779,798.472229   C577.576843,824.283875 593.849915,841.260864 619.492737,849.023865   C622.718018,850.000305 626.241272,850.226013 629.000000,852.500000  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "line-10",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1341.000000,452.000000   C1342.184448,462.333344 1341.090088,472.670807 1340.808105,482.994751   C1340.772827,484.283142 1340.763062,485.711273 1341.097168,486.717743   C1344.965576,498.368469 1342.511963,510.238251 1342.419922,521.999390   C1342.370361,528.336182 1341.703491,534.690918 1340.952759,540.994385   C1339.798950,550.682373 1338.925415,560.462158 1336.857544,569.969055   C1333.938599,583.387695 1331.101074,596.849487 1327.038696,610.011963   C1321.761475,627.110474 1316.101196,644.055359 1309.060669,660.525940   C1308.064697,662.855774 1306.896118,664.875183 1305.000000,666.500000  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "line-11",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1093.500000,140.000000   C1090.273926,136.373215 1085.735107,137.775146 1081.995361,137.675400   C1036.951294,136.473923 996.285889,149.809906 959.508423,175.512070   C948.805969,182.991547 939.004456,191.535049 929.970337,200.971588   C928.472534,202.536057 927.269043,204.803711 924.500000,204.500000  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "line-12",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M896.500000,154.000000   C887.804688,147.870041 877.934753,145.393448 867.498901,145.032166   C848.326965,144.368393 830.666504,149.873749 813.455933,157.905579   C794.444824,166.777664 777.549561,178.541824 761.873596,192.356552   C759.375183,194.558350 756.341125,196.598999 753.205139,198.364395   C748.170715,201.198502 744.499634,206.466751 742.095154,212.041046   C741.455444,213.524231 741.079529,214.796082 739.508362,215.518158   C732.905029,218.552902 733.176636,226.291702 729.000000,231.000000   C730.793213,238.291977 726.125671,244.287079 724.855042,250.972443   C723.772827,256.666443 723.191284,262.468903 721.170349,268.061554   C719.619019,272.354584 716.734253,274.156525 712.989746,275.470825   C712.396179,275.679169 711.289978,275.222595 711.055603,275.540924   C706.322083,281.968964 698.294128,285.107086 694.429932,292.463165   C692.631470,295.886780 690.142700,299.173248 688.778259,302.610443   C687.109863,306.813324 686.693298,311.938812 687.284851,316.462738   C687.676270,319.456543 687.059204,321.456848 686.183899,324.061798   C685.205139,326.974731 684.529602,330.063477 683.477295,332.991821   C681.243591,339.207703 676.336792,343.879883 674.214966,350.407349   C672.162720,356.720642 671.719910,363.317291 669.483643,369.494080   C667.728088,374.343292 667.146790,379.375824 663.253235,383.726624   C659.573975,387.837952 657.917542,393.795593 655.528381,399.013000   C653.880432,402.611908 651.790771,406.222717 651.196838,410.030701   C650.587036,413.940430 648.347473,415.780090 645.485352,417.475281   C643.836243,418.452057 642.862610,419.724426 641.911316,421.451111   C635.952332,432.266693 630.617798,443.364868 626.538086,455.013336   C621.515076,469.354919 617.211365,483.873322 614.834839,498.973999   C613.837463,505.311890 614.244812,511.957367 611.500000,518.000000  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "line-13",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1198.000000,169.000000   C1202.218994,167.974777 1205.561890,170.617340 1208.947144,172.119171   C1229.425049,181.203781 1247.558472,193.508789 1262.093018,210.922333   C1268.704834,218.843719 1273.379028,228.182068 1281.303589,235.221115   C1284.837402,238.360062 1289.175171,239.524323 1292.683472,242.803757   C1312.748535,261.559967 1326.892090,283.809326 1335.014160,309.995636   C1341.188477,329.902100 1342.618652,350.327911 1342.000000,371.000000   C1337.610229,380.295288 1341.145142,390.007629 1340.502808,399.500183   C1340.480347,399.832001 1340.645508,400.311829 1340.478882,400.478882   C1335.501465,405.466522 1337.344604,412.942993 1333.711792,418.635162   C1331.432983,422.205383 1333.316528,427.172424 1333.000000,431.500000  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "line-14",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1340.500000,487.000000   C1336.684937,489.476959 1336.585327,493.762939 1335.531982,497.508972   C1325.960815,531.545532 1311.409546,563.248596 1291.617432,592.579224   C1290.044067,594.910828 1288.410767,596.468567 1286.000000,597.500000  "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "line-15",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1212.500000,388.000000   C1207.783081,385.979370 1202.790894,386.830902 1198.005981,387.103912   C1174.981934,388.417633 1152.989746,394.475006 1131.514526,402.538788   C1123.547729,405.530273 1116.147095,409.896179 1108.007080,412.521820   C1105.875854,413.209290 1104.385498,415.235413 1104.124023,417.018188   C1102.163452,430.386353 1095.182129,441.950287 1091.068237,454.522308   C1089.398315,459.625885 1087.146851,463.963745 1082.549805,467.073547   C1079.913330,468.856995 1078.820190,471.546692 1079.877319,475.037170   C1080.316162,476.486572 1080.699219,478.490448 1079.026489,480.028809   C1075.246094,483.505707 1074.863159,488.756714 1072.596680,493.051025   C1070.909790,496.247314 1070.951660,500.410736 1066.022827,501.151520   C1064.820190,501.332275 1064.070068,503.383636 1063.359619,504.935730   C1061.627808,508.719269 1058.954956,511.958893 1056.333618,515.264526   C1053.914795,518.314819 1052.617065,522.657593 1050.014771,526.011475   C1047.317627,529.487366 1045.192383,533.400574 1042.000000,536.500000  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "line-16",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1192.000000,430.000000   C1186.090576,426.573608 1179.749634,428.516052 1174.042358,429.703522   C1146.789185,435.373962 1120.955200,445.136475 1096.467285,458.439850   C1094.566406,459.472504 1092.389893,460.467438 1090.000000,460.000000  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "line-17",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M852.500000,244.000000   C847.980347,239.713745 850.490234,231.474640 842.147949,228.574402   C836.040649,226.451096 830.308105,222.437134 824.019409,219.950897   C806.934814,213.196503 789.131104,211.265411 771.005676,212.120346   C763.648315,212.467361 756.237366,213.172684 748.977539,214.906021   C746.611450,215.470932 743.920349,215.861542 741.500000,214.500000  "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "line-18",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1067.000000,758.000000   C1056.430542,765.965271 1044.522583,771.674561 1032.968628,777.942139   C1015.276489,787.539062 997.167419,796.334595 979.002930,805.006104   C975.270569,806.787903 970.685913,807.210571 968.500000,811.500000  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "line-19",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1093.500000,141.000000   C1088.890869,144.420349 1083.132080,143.978439 1077.956055,145.331711   C1054.708618,151.409622 1034.659790,163.095016 1016.461548,178.454437   C1010.851929,183.188965 1005.721924,188.380142 1000.484009,193.483566   C998.980530,194.948471 997.714172,196.516586 997.000000,198.500000  "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "line-20",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M1067.500000,231.000000   C1072.836548,227.033966 1079.745117,226.306458 1085.097046,222.124146   C1088.609741,219.379196 1093.461060,220.459122 1097.475464,221.144104   C1110.873657,223.430359 1124.237061,226.035629 1137.461670,229.162109   C1142.065918,230.250641 1145.830933,233.985062 1150.483154,235.550247   C1151.433228,235.869904 1152.106079,237.313599 1153.009155,237.427353   C1164.949585,238.931366 1173.994507,246.874252 1184.384033,251.747147   C1188.705688,253.774033 1193.025024,256.533875 1197.000000,259.500000  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "line-21",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M878.500000,519.000000   C875.445496,522.244629 871.161926,520.982971 867.493774,521.977051   C864.053040,522.909424 860.256165,522.053223 856.636169,523.907471   C859.513794,527.000000 857.133057,530.014465 856.960205,532.997681   C855.705017,554.653381 856.071594,576.329041 855.984192,597.999939   C855.963379,603.168274 857.823547,608.402893 855.500000,613.500000  "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "line-22",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1201.000000,332.500000   C1182.638428,351.146545 1162.156982,367.209778 1139.884155,380.810272   C1131.882202,385.696533 1123.472656,390.509186 1113.993896,392.470398   C1111.886475,392.906403 1110.152100,394.496063 1110.161255,395.999023   C1110.191772,400.980682 1108.128296,405.360168 1107.041870,410.009796   C1106.902710,410.605011 1107.333252,411.333344 1107.499878,412.000031  "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "line-23",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M734.500000,562.500000   C736.238464,563.710388 738.011414,563.363037 740.012024,563.087463   C746.140991,562.243103 752.426758,562.788757 758.098450,559.153625   C760.089844,557.877258 762.843872,559.023193 764.542603,561.470398   C766.595032,564.427124 766.844788,568.901855 765.032593,572.516357   C763.711670,575.150757 763.980591,578.298218 763.781128,581.020569   C763.403381,586.175903 762.533142,591.317322 762.511902,596.500061   C762.470947,606.499878 762.417908,616.500916 762.527222,626.499695   C762.607605,633.853699 764.265198,641.091431 764.242554,648.500732   C764.237305,650.216064 765.867126,652.821228 768.450562,654.099915   C773.125183,656.413757 777.500000,659.333374 782.000000,662.000000  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "line-24",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1101.500000,276.000000   C1091.045654,278.846344 1080.344238,280.540833 1069.940918,283.812103   C1056.509766,288.035492 1043.284912,292.615417 1030.487061,298.471771   C1026.690308,300.209229 1022.738770,301.608521 1018.441040,303.329865   C1025.494507,317.004028 1023.311829,330.291138 1018.000000,343.500000  "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "line-25",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M654.500000,541.500000   C646.014771,540.800842 638.181946,537.435852 629.996521,535.514771   C624.356262,534.191162 619.239563,536.789734 614.017822,538.072449   C597.774841,542.062500 584.286926,550.958496 573.070374,563.065186   C559.619324,577.583618 551.271545,594.749756 548.349731,614.477722   C548.200684,615.483887 549.035889,616.166687 548.500000,617.000000  "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "line-26",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M618.000000,593.000000   C613.654968,594.676208 613.391113,599.095764 611.369873,602.420898   C606.784973,609.963013 602.693298,617.751099 598.462158,625.479248   C590.579224,639.877441 582.924377,654.375000 576.448669,669.477966   C575.310242,672.132996 573.500000,674.500000 572.000000,677.000000  "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "line-27",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M687.000000,305.000000   C682.911987,305.983917 681.313171,309.672668 679.030273,312.524261   C664.175415,331.079865 650.783020,350.659882 638.531372,371.018860   C636.842590,373.825195 634.587952,376.446503 634.500000,380.000000  "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "line-28",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M612.500000,538.000000   C612.167847,533.481506 611.436646,529.054688 612.835999,524.450134   C613.562622,522.059204 613.021973,518.651672 609.961304,517.614136   C607.410645,516.749451 606.759949,514.405762 605.066040,512.924438   C602.328796,510.530823 600.822998,507.142853 597.874756,504.570496   C595.504822,502.502747 594.205017,496.662415 595.668762,492.560242   C597.210632,488.239258 597.084534,483.819458 597.970825,479.494019   C600.383240,467.721924 601.151367,455.542999 606.554382,444.526672   C607.387146,442.828705 606.866577,441.450409 605.947510,440.553833   C599.283142,434.052734 595.355835,425.714111 590.159668,417.304230   C586.106506,421.250214 586.009827,426.446381 585.115723,431.022614   C583.184326,440.908356 582.769714,450.915405 583.938171,461.007172   C585.084290,470.905273 588.049622,480.253571 591.530151,489.488647   C592.103943,491.011108 593.277771,492.148163 595.000000,492.500000  "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "line-29",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1340.000000,450.500000   C1336.518799,447.020660 1337.911499,442.005951 1336.078247,437.964508   C1335.189209,436.004456 1334.882690,433.771088 1333.561646,432.004852   C1332.053223,431.899780 1331.456787,432.689240 1330.968262,433.988068   C1327.551636,443.070251 1322.473877,451.574432 1321.496460,461.499664   C1321.184448,464.668213 1320.120361,467.257599 1317.589233,469.596527   C1313.896240,473.008942 1311.658203,477.391907 1310.305054,482.447845   C1309.481445,485.525146 1311.117310,487.810089 1311.009888,490.500397   C1310.683838,498.667389 1311.773193,506.891174 1310.013550,515.002930   C1309.909912,515.480469 1309.823975,516.089600 1310.026245,516.486694   C1313.566406,523.440308 1309.380127,529.565674 1308.013672,536.002930   C1304.819092,551.053467 1298.790161,565.079224 1292.429321,578.967651   C1291.256958,581.527405 1289.560547,584.155273 1287.410278,585.888672   C1283.938721,588.687195 1284.002197,591.909790 1285.034546,595.490051   C1285.817749,598.206482 1285.101562,599.966064 1283.112427,602.104553   C1279.858032,605.603271 1276.542847,609.390991 1275.102173,614.031738   C1273.401855,619.508667 1268.558350,622.269531 1265.348267,626.381531   C1249.597656,646.557434 1231.820557,664.838318 1211.442993,680.425537   C1208.049194,683.021606 1204.816406,686.384155 1200.000000,686.500000  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "line-30",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M688.000000,496.500000   C678.352051,508.194336 670.294861,520.799927 666.016113,535.504700   C662.604187,547.230286 661.791199,559.066895 665.000000,571.000000  "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "line-31",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1273.000000,584.000000   C1267.967773,596.534058 1259.302124,606.652832 1250.986694,616.989258   C1241.345215,628.973938 1229.953613,639.280884 1218.953857,649.952393   C1217.214478,651.639771 1215.436890,653.763794 1212.500000,653.500000  "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "line-32",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1291.000000,337.500000   C1293.468262,334.281738 1293.045044,331.239624 1291.624023,327.453461   C1283.294189,305.260010 1269.651855,287.042877 1251.550781,271.939117   C1249.738647,270.427002 1248.063599,270.155701 1246.000000,270.500000  "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "line-33",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M855.000000,729.500000   C850.912659,728.957581 847.581665,731.147034 843.989380,732.471252   C839.154968,734.253357 834.334778,735.614502 832.287964,741.425293   C831.649414,743.238159 828.231140,743.894104 826.551147,745.551758   C821.795593,750.244263 815.680054,752.940857 810.461670,756.950134   C804.965942,761.172546 799.149780,764.976379 793.507996,769.011108   C791.091675,770.739014 788.864502,772.773560 785.483887,772.078247   C785.102844,771.999878 784.429260,772.947266 784.011108,773.508301   C780.332947,778.443176 775.080139,781.267212 770.148132,784.712097   C764.088135,788.944824 757.559387,792.325134 751.446655,796.420349   C745.187561,800.613403 738.543579,804.242920 731.992188,807.986328   C708.527222,821.394226 685.093262,834.847412 659.550537,844.138855   C656.816162,845.133423 653.399780,846.166382 652.000000,849.500000  "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "line-34",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1240.500000,261.000000   C1240.799561,255.188980 1242.991455,249.079147 1237.054810,244.429947   C1235.105103,242.903091 1237.144897,240.321640 1236.223999,237.914291   C1233.172729,229.938354 1229.070557,222.612534 1224.438965,215.539948   C1223.482910,214.079971 1222.409058,212.947357 1222.429810,210.999252   C1222.449585,209.149216 1220.807739,208.160065 1219.530029,206.967758   C1213.060181,200.929840 1204.889038,201.399979 1196.996948,201.072098   C1193.181030,200.913559 1189.396851,199.445374 1185.467163,200.912094   C1183.997437,201.460663 1183.137085,200.158234 1182.972656,198.502716   C1182.523438,193.978516 1178.747681,190.634735 1178.437012,186.004227   C1178.390259,185.307190 1177.572510,184.594131 1176.988892,184.011124   C1170.279663,177.308899 1164.440430,169.868301 1158.358398,162.618835   C1155.470093,159.176254 1150.381714,157.807602 1146.038330,158.688751   C1139.034424,160.109619 1131.979614,159.551544 1124.995728,160.467560   C1100.587524,163.668961 1076.689453,169.128998 1055.740601,182.380356   C1049.012329,186.636429 1041.560181,189.928940 1035.213257,195.151581   C1032.256226,197.584854 1027.329834,199.571060 1021.956177,198.808746   C1017.334106,198.153046 1012.333313,200.166687 1007.500000,201.000015  "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "line-35",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M823.500000,256.000000   C815.526978,251.204193 808.450134,256.044250 801.557922,258.653076   C786.244873,264.449402 771.652954,271.832458 757.919312,280.877472   C755.947144,282.176361 754.585876,283.335571 754.000000,285.500000  "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "line-36",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M626.000000,459.000000   C629.991638,460.183441 632.517151,464.046478 636.973999,464.682373   C638.642761,464.920471 639.038757,467.078339 638.658630,469.524658   C636.260620,484.955383 636.511414,500.470245 637.947388,516.004883   C638.591797,522.976135 638.666626,530.000000 638.999939,537.000000  "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "line-37",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1308.000000,448.500000   C1305.721558,445.926147 1305.977539,442.498444 1305.078491,439.476654   C1304.338013,436.988007 1303.466675,434.578064 1301.442383,433.077698   C1299.610962,431.720276 1298.377563,432.287811 1298.462402,435.001190   C1299.116699,455.916840 1294.755371,476.063477 1289.076538,496.021759   C1288.506104,498.026154 1289.000000,500.333344 1289.000000,502.500000  "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "line-38",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1285.000000,518.500000   C1288.894775,522.546326 1287.443970,527.824097 1287.872314,532.511658   C1289.311279,548.250610 1288.278076,563.932800 1285.536011,579.506348   C1285.136475,581.775452 1285.134888,584.148376 1287.000000,586.000000  "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "line-39",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M790.000000,562.000000   C808.677185,582.467468 829.577515,600.193054 854.085083,613.341431   C855.516235,614.109192 856.779724,614.997864 857.396606,616.060059   C859.328430,619.385742 860.948853,621.383240 865.611145,619.834534   C867.613831,619.169250 870.911072,622.033081 873.482910,623.529358   C878.020447,626.169556 884.571899,624.039001 887.039917,620.024536   C890.379456,614.592529 894.120911,609.407471 897.454468,603.972107   C899.442139,600.731262 902.919312,599.442810 905.541321,597.045227   C914.600708,588.761230 923.382751,580.071777 933.138062,572.682251   C941.415588,566.412231 947.602722,558.437683 954.525085,551.023438   C955.671570,549.795410 956.237183,547.976379 959.074097,548.715698   C960.662170,549.129639 963.089294,546.793762 964.977661,545.468140   C967.402893,543.765686 969.666687,541.833374 972.000000,540.000000  "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "line-41",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M851.500000,787.000000   C844.754822,791.181763 837.038147,792.460815 829.479553,793.891907   C822.408508,795.230591 815.185059,795.987610 807.994202,796.398987   C802.189453,796.730896 796.325928,796.282898 790.505432,795.914246   C789.135376,795.827454 787.833313,794.666687 786.500000,794.000000  "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "line-42",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1284.500000,239.000000   C1284.232666,241.191818 1284.956421,243.106949 1285.984375,245.008423   C1294.772583,261.264740 1300.056763,278.827942 1304.898193,296.527832   C1305.480347,298.656372 1304.666748,301.166656 1304.500000,303.500000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-43",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 537.03179,511.82081 c -3.49255,-0.40497 -6.40546,1.28351 -9.51569,2.45856 -17.71661,6.69348 -35.33014,13.72259 -53.97607,17.58124 -0.75293,0.15588 -1.38489,0.89599 -2.16815,1.4284 1.97839,6.75275 0.61853,13.73944 2.08026,20.54889 2.94879,13.73682 9.54022,25.14429 19.47455,35.08789 7.67419,7.68134 34.97448,13.82478 44.65472,17.96455",
    style: {
      display: "inline"
    },
    clipPath: "url(#clipPath57)",
    transform: "translate(77.802788,86.098602)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "line-44",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M897.000000,155.500000   C889.731384,162.749313 882.703613,170.215363 875.968567,177.972702   C867.812317,187.367081 860.567810,197.328995 854.918762,208.458771   C853.726624,210.807617 853.523010,213.064453 853.500000,215.500000  "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "line-45",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 1051.5,228 c -4.6393,3.30153 -10.3715,3.47484 -15.5566,4.77368 -13.4626,3.37222 -26.4313,8.08133 -39.41679,12.7995 -1.92816,0.70059 -11.13704,12.15816 -12.98189,12.19831"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "line-46",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M746.000000,329.000000   C736.943420,335.338776 728.086426,341.877380 719.923767,349.417511   C710.695923,357.941620 703.331177,367.779602 697.027466,378.516144   C696.042053,380.194611 695.025940,381.779419 693.500000,383.000000  "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "line-47",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M767.000000,563.500000   C782.676147,565.444946 796.764343,578.398010 800.999634,594.500122   C803.585938,604.333008 803.566162,614.163391 801.015686,624.004089   C800.686218,625.275269 799.906616,626.159973 799.000000,627.000000  "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "line-48",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M617.500000,694.500000   C623.604126,703.398193 632.541016,708.470215 641.973206,713.055115   C652.786621,718.311401 663.947083,722.113281 676.000000,723.000000  "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "line-49",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M651.000000,415.500000   C654.471558,419.878479 652.914612,425.191498 653.347656,430.013672   C654.682678,444.879578 658.168579,458.926910 666.535461,471.476379   C667.344604,472.690063 666.733826,473.847565 667.000000,475.000000  "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "line-50",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1310.500000,317.500000   C1314.590210,320.609711 1316.577393,325.242126 1318.959229,329.522675   C1326.193604,342.523376 1331.252197,356.456635 1335.941772,370.519409   C1336.627930,372.576965 1337.208618,374.456085 1339.250000,375.500000  "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "line-51",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M752.500000,563.000000   C750.337463,571.985535 746.492188,580.420227 744.295471,589.450256   C742.076050,598.573120 740.420288,607.665771 740.063293,617.002441   C739.994751,618.793396 739.326660,620.331970 739.000000,622.000000  "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "line-52",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M782.000000,570.000000   C781.833313,570.666687 781.760864,571.375305 781.485229,571.993408   C778.924744,577.737061 772.893738,582.090820 774.500000,589.500000   C770.052673,595.135315 770.155701,601.810730 769.964294,608.498962   C769.500244,624.713257 777.929993,635.701660 791.088318,643.347961   C797.320679,646.969543 804.040222,649.949585 811.443726,651.306885   C813.798828,651.738586 815.854248,651.061218 818.000000,651.500000  "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "line-53",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M728.500000,231.500000   C725.538208,231.717590 723.919128,234.082565 722.586731,236.058487   C712.966675,250.324448 704.200500,265.086487 697.444458,280.976379   C696.489441,283.222351 697.083557,285.326935 697.000000,287.500000  "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "line-54",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1181.000000,451.000000   C1178.209595,450.928680 1177.326660,452.938324 1175.911255,454.937134   C1164.737427,470.716858 1152.927368,486.061707 1142.182129,502.121857   C1137.274658,509.456635 1131.369629,515.125916 1124.389648,520.192444   C1123.105469,521.124695 1121.065796,522.924377 1121.260254,526.015076   C1121.465698,529.281555 1117.957764,531.436523 1115.956787,533.965820   C1113.470459,537.108459 1109.034302,539.704224 1108.423218,543.076660   C1107.698120,547.077759 1104.886108,548.182434 1102.946533,550.454407   C1100.932495,552.813660 1098.010864,553.268188 1095.000000,553.000000  "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "line-55",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M734.000000,722.000000   C739.328613,725.462708 745.519836,725.519592 751.494568,726.532104   C763.152405,728.507751 774.797852,728.571106 786.509338,727.072876   C788.482300,726.820435 790.139526,726.432068 791.500000,725.000000  "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "line-56",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1183.000000,200.000000   C1171.244263,199.961227 1159.642700,201.719696 1148.000000,203.000000   C1143.019897,208.160934 1136.655884,205.299667 1130.991089,205.537369   C1125.838989,205.753555 1122.088745,208.832077 1117.560669,210.200836   C1111.178467,212.130051 1104.442993,213.659760 1099.000000,218.000000  "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "line-57",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1166.500000,275.000000   C1164.898560,277.302979 1162.174683,277.274902 1159.994263,277.392395   C1141.938232,278.365051 1125.272461,284.182983 1109.000000,291.500000  "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "line-58",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M907.000000,163.500015   C894.000000,176.833344 881.188293,190.358795 867.892700,203.390549   C863.539978,207.656891 860.376038,212.960236 854.196655,215.911697   C849.868896,217.978775 847.668640,224.081467 845.500000,229.000000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-59",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 885.40877,400.66206 c 6.32196,-0.36441 23.26097,-0.20259 29.59044,-0.10988 8.00317,0.11728 16.01965,0.40287 23.9862,1.11182 1.76624,0.15714 3.3479,-0.48245 5.01459,-0.164",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "line-60",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M859.000000,795.500000   C849.783081,806.596802 840.651001,817.772461 835.531677,831.511780   C832.510620,839.619934 837.776917,848.609436 844.908813,846.665405   C850.418518,845.163513 856.263916,845.494080 861.510681,843.022644   C866.249023,840.790649 870.826477,838.558960 876.507935,838.721008   C879.462769,838.805237 882.590759,836.155518 885.481445,834.468262   C891.874329,830.736938 898.131470,826.772949 904.525940,823.044434   C906.035461,822.164307 906.951904,821.054016 907.500000,819.500000  "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "line-61",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M875.000000,277.000000   C870.850891,277.425507 866.694153,277.710327 863.474854,280.975189   C861.737671,282.736786 859.605225,280.818909 857.465332,281.363770   C839.673767,285.893982 822.081360,290.938232 805.508789,299.017975   C803.595276,299.950867 796.617432,299.362122 795.500000,298.000000   C792.696045,294.582001 792.612915,290.756256 795.532288,287.529236   C797.186646,285.700653 799.043945,283.999878 801.028870,282.539276   C803.985229,280.363861 806.596558,277.978638 807.995911,274.498352   C808.192139,274.010254 808.208679,273.164215 808.518311,273.049255   C815.721741,270.375366 817.001099,262.249420 822.438721,257.923004   C823.678650,256.936462 824.400696,254.977798 826.015076,254.558014   C834.417542,252.373184 841.689148,246.976532 850.500000,246.000000  "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "line-62",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m 1161.6621,320.9703 c -6.3625,-0.55807 -12.4585,21.04548 -18.2628,22.63009 -2.8738,0.78458 -11.6429,8.52152 -14.5369,9.091 -2.8941,0.56948 -12.8617,4.95822 -15.7786,5.32453 -2.9168,0.36631 -14.8704,4.55784 -17.8125,4.7329 -2.9421,0.17506 -14.1376,1.04224 -17.1076,1.03798 -1.8358,-0.003 -15.1349,-0.37338 -16.6637,-0.7868"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "line-63",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M661.500000,384.500000   C653.077454,380.521973 643.829285,381.684479 634.985046,380.348969   C633.088013,380.062500 631.355652,381.550293 630.504333,383.501892   C624.238770,397.865204 616.978943,411.787445 611.485229,426.494476   C609.785156,431.045532 609.093872,436.013550 606.000000,440.000000  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "line-65",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1277.000000,359.500000   C1267.736938,341.735992 1257.577148,324.522919 1245.462402,308.528534   C1244.414429,307.145081 1243.477905,305.430054 1241.500000,305.000000  "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "line-66",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M956.000000,535.000000   C954.231323,532.437988 953.268005,529.525818 953.057495,526.496033   C952.779968,522.502136 950.927368,520.369995 947.017273,519.428284   C943.601135,518.605530 940.334473,517.163330 936.999268,516.002075   C936.003906,515.655457 934.484131,515.638550 934.078674,514.953430   C929.273193,506.831848 921.380188,510.250610 915.616028,511.524872   C910.872253,512.573608 905.838806,514.156982 900.961121,515.339722   C894.788696,516.836426 888.349487,517.340454 881.993713,517.932251   C878.409729,518.265991 874.678711,516.679993 871.662537,515.561707   C867.708679,514.095764 864.157043,515.070618 860.500000,514.500000  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "line-67",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1234.000000,391.500000   C1232.912231,408.188904 1229.469971,424.365417 1223.517700,440.006744   C1222.643921,442.303009 1221.012085,443.794220 1219.000000,445.000000  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "line-68",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M922.000000,214.500000   C921.833313,214.500000 921.620972,214.432373 921.506531,214.509705   C913.625244,219.834839 904.140625,220.769547 895.519287,224.050720   C886.931213,227.319260 878.476807,230.945129 870.010010,234.523697   C865.943237,236.242584 861.607727,237.549591 858.500000,241.000000  "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "line-69",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1036.500000,195.500000   C1037.970825,196.087433 1039.238892,197.139023 1041.001465,197.021027   C1048.200317,196.539062 1055.333862,198.028030 1062.499146,197.933731   C1074.064087,197.781525 1085.491577,199.473679 1096.998535,200.030853   C1098.670776,200.111832 1100.315674,200.623169 1101.500000,202.000000  "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "line-70",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M1198.000000,261.000000   C1206.225098,265.107147 1214.099731,270.274872 1219.720215,277.226227   C1225.654419,284.565491 1233.690918,288.899872 1240.856445,293.999054   C1246.516846,298.027039 1253.191772,301.340698 1258.925293,305.600586   C1268.156494,312.459229 1275.437500,321.355774 1283.241943,329.775726   C1292.395020,339.650604 1297.143677,351.702148 1303.558350,362.966766   C1304.052979,363.835571 1304.601318,364.755280 1305.411621,365.586151   C1311.369629,371.694458 1310.731323,379.972534 1309.479980,386.906158   C1308.571777,391.939026 1306.520874,397.285461 1304.967285,402.490234   C1304.697876,403.392426 1304.202515,404.526581 1303.466675,404.940735   C1299.139648,407.376129 1299.707764,410.945557 1300.407104,415.015961   C1301.408447,420.842102 1299.445923,426.644531 1299.500000,432.500000  "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "line-71",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M995.000000,540.000000   C993.059570,547.848572 992.427063,556.053101 988.967773,563.484985   C986.046387,569.761292 985.094116,577.171936 978.091736,581.161011   C976.308716,582.176758 976.517151,585.215393 977.484497,587.506531   C978.611877,590.176880 977.575378,591.975891 975.583313,594.078918   C969.004822,601.023987 962.276550,607.775818 955.025879,614.029968   C948.353455,619.785400 940.518188,623.638611 932.936829,627.887207   C931.546387,628.666443 929.333313,629.165222 927.500000,628.000000  "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "line-72",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 633,636 c -9.67188,-5.07129 -19.52338,0.38721 -24.47736,8.01471 -5.34509,8.22955 -5.35925,17.03216 -3.75451,26.52447 1.30932,7.74524 4.64532,14.09284 8.5766,20.55524 1.33484,2.19428 2.89343,2.88562 4.6391,2.56702 12.64764,-2.3086 24.41027,-6.43061 30.92675,-18.70886 2.2298,-4.20118 4.59994,-12.48403 6.26657,-16.98403"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "line-73",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1165.500000,273.000000   C1164.348389,271.454865 1162.693115,271.529480 1161.000488,271.481415   C1146.115845,271.058685 1131.314819,272.118164 1116.480469,273.242737   C1111.732788,273.602600 1107.902832,274.375031 1103.761841,278.288055   C1095.203369,261.355896 1083.562744,247.193024 1069.000000,235.500000  "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "line-74",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M792.500000,292.000000   C785.373962,294.388733 780.767944,300.224731 777.862183,306.176819   C774.986084,312.067993 770.389465,314.693359 765.401367,316.762115   C761.776428,318.265564 759.992615,320.562775 757.924866,323.446136   C749.956421,334.557861 745.625732,347.484711 739.642761,359.570679   C737.089539,364.728424 737.285522,370.912933 735.585388,376.525848   C732.389526,387.076691 732.334290,398.104095 731.471985,408.997772   C731.338867,410.680298 730.833374,412.333344 730.500000,414.000000  "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "line-75",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1320.500000,468.000000   C1322.589844,470.182007 1322.190430,472.951355 1321.949219,475.495178   C1320.687134,488.803131 1318.276978,501.934235 1315.488525,514.997559   C1315.119385,516.726440 1314.278442,518.247314 1313.000000,519.500000  "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "line-76",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M752.000000,331.000000   C748.247620,329.058716 744.211304,327.536255 741.977112,323.512695   C740.936768,321.639069 739.234924,321.581207 737.504883,322.509155   C725.038452,329.195618 713.084900,336.609619 701.887878,345.356445   C696.455566,349.600006 692.813232,355.988068 686.000000,358.500000  "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "line-77",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1066.000000,233.500000   C1054.718872,243.409744 1042.118286,251.531921 1029.411133,259.355682   C1018.445129,266.107422 1011.271912,276.261139 1003.000000,285.500000  "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "line-78",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1241.500000,249.000000   C1246.301636,248.808624 1249.792725,252.427917 1252.763672,254.796371   C1262.251099,262.359741 1272.029907,269.691376 1280.518188,278.482422   C1287.334839,285.542297 1293.519653,293.169800 1300.176758,300.335754   C1304.295166,304.768860 1307.662720,308.984558 1309.138672,314.965790   C1310.153564,319.078644 1308.601807,322.910553 1309.322266,327.031067   C1311.107300,337.240417 1310.462402,347.656677 1310.512085,357.999939   C1310.522949,360.255219 1309.639648,362.033173 1308.000000,363.500000  "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "line-79",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M940.000000,569.000000   C940.220581,574.895447 936.106934,579.247009 934.300171,584.430359   C930.577087,595.111084 926.505432,605.584351 925.368164,616.986877   C925.117126,619.503845 925.375244,621.943420 926.155762,623.939087   C927.887695,628.367188 926.602173,630.875427 922.500000,632.500000  "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "line-80",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1278.500000,461.500000   C1278.500000,459.666656 1277.920532,457.579987 1278.593384,456.040833   C1283.204346,445.494568 1279.052490,435.613098 1275.788940,426.072174   C1272.243164,415.705963 1265.818848,406.753571 1256.467407,400.549133   C1246.031128,393.624908 1234.435181,389.497284 1221.988037,388.106659   C1219.465210,387.824829 1217.007324,385.929688 1214.537354,387.080200   C1211.796021,388.357208 1212.266235,391.721802 1210.985596,393.991852   C1205.560425,403.608307 1201.234741,413.830048 1195.010620,423.007172   C1194.595825,423.618683 1194.000366,424.359253 1194.050049,424.996124   C1194.767212,434.209473 1187.608032,439.801575 1183.942139,446.970428   C1181.161743,452.407806 1180.755859,458.523682 1178.131836,464.062469   C1172.701538,475.524292 1169.812744,487.937592 1166.000000,500.000000  "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "line-81",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1017.000000,748.000000   C1016.947571,750.366638 1014.992065,751.426270 1013.462341,752.443359   C1001.029358,760.710754 988.435730,768.738037 976.057495,777.085144   C973.747192,778.643066 971.532288,779.029724 969.000000,779.000000  "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "line-82",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1240.000000,295.000000   C1241.984863,314.776794 1234.359009,332.738708 1228.613770,350.877686   C1226.985840,356.017334 1227.118896,359.013824 1229.294067,363.597717   C1233.190430,371.807892 1233.838745,380.914276 1233.500000,390.000000  "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "line-83",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M799.000000,783.500000   C804.827576,787.913818 811.831482,788.051636 818.494446,787.831238   C828.428711,787.502625 838.331482,786.080444 848.000000,783.500000  "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "line-84",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M973.499939,758.500000   C973.333252,759.000000 972.887207,759.819336 973.040588,759.953491   C977.542480,763.892029 974.609070,767.428833 972.491699,770.995056   C971.878906,772.027039 971.156250,772.993347 970.504944,774.003174   C970.238892,774.415710 961.939270,783.698730 961.499023,783.998535   C957.334045,786.834351 953.133911,789.619934 949.006836,792.509766   C940.484192,798.477417 932.066040,804.597412 923.456421,810.435669   C921.124329,812.017151 919.002075,813.623474 917.500000,816.000000  "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "line-85",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M693.500000,500.000000   C692.750000,500.861115 692.481628,501.837463 692.479492,502.999969   C692.449402,519.174805 691.806824,535.362488 693.527100,551.497131   C693.653809,552.685791 694.166626,553.833374 694.499939,555.000000  "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "line-86",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M934.000061,515.500000   C931.333374,522.333374 928.540894,529.120911 926.032532,536.011841   C923.056335,544.187744 917.674683,551.479126 917.000000,560.500000   C912.460693,564.520630 911.775452,571.958557 905.006653,574.021790   C904.456177,574.189697 903.930969,574.596436 903.510071,575.010254   C889.980225,588.312073 876.753296,601.877319 866.518799,618.011963   C866.368042,618.249573 866.500000,618.666687 866.500000,619.000000  "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "line-87",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1341.000000,402.500000   C1344.501953,407.182404 1343.399292,412.863800 1343.797363,418.015656   C1344.514404,427.293579 1343.932983,436.667542 1344.054077,445.999298   C1344.079712,447.976654 1343.563843,449.398773 1342.000000,450.500000  "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "line-88",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M671.000000,674.500000   C669.684143,675.711487 669.079102,677.178650 668.975159,678.998596   C668.217224,692.271545 670.662109,705.038391 675.084167,717.470093   C675.376282,718.291321 675.968018,718.984314 676.032898,719.997925   C676.272339,723.740234 677.852600,724.786194 682.002441,724.745300   C688.475464,724.681396 694.998474,724.924011 701.500183,724.972412   C703.332153,724.985962 705.166687,724.666626 707.000000,724.499939  "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "line-89",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M647.000000,417.500000   C648.296326,422.854950 645.592224,427.542023 644.504639,432.501007   C642.542969,441.445801 640.236023,450.321777 639.450745,459.495789   C639.291260,461.358276 638.500061,463.166687 638.000061,465.000000  "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "line-90",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1088.500000,566.500000   C1101.753174,571.331116 1115.336670,570.671082 1129.005859,569.049622   C1131.166626,568.793396 1133.504028,568.557373 1135.500000,570.000000  "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "line-91",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M927.500000,449.000061   C918.500000,453.666718 909.346436,458.064575 900.550537,463.088501   C893.982788,466.839752 886.847412,469.834717 881.500000,475.500000  "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "line-92",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M701.000000,600.500000   C705.147461,605.409302 705.406555,611.822632 707.392761,617.537292   C711.086792,628.165527 715.221008,638.563232 720.138306,648.620544   C727.666687,645.465393 734.889526,647.413879 741.958191,648.725220   C743.608276,649.031372 745.326721,649.199707 747.000000,649.500000  "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "line-93",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M981.000000,215.000000   C974.611633,216.091141 968.413269,216.876007 962.832947,221.288742   C957.967957,225.135864 951.599304,227.040909 946.017090,230.031921   C939.112183,233.731674 932.368958,237.732681 925.475769,241.455154   C923.679749,242.425064 921.907776,244.131210 919.500000,243.000000  "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "line-94",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1274.500000,465.000000   C1275.000000,465.166687 1275.934326,465.327301 1275.936890,465.500885   C1276.013794,471.020691 1277.253418,476.577087 1273.113770,481.593903   C1270.503662,484.757050 1268.999146,488.832855 1267.001465,492.500824   C1266.823364,492.827911 1266.437378,493.267029 1266.533081,493.485504   C1270.249512,501.976593 1262.782959,506.769409 1259.866821,512.937073   C1257.121460,518.743958 1254.255615,524.756226 1248.513184,528.520142   C1248.243774,528.696655 1248.084351,529.149841 1248.012207,529.502502   C1245.773193,540.440125 1236.108765,545.978760 1229.768311,553.812439   C1222.547363,562.733826 1214.772339,571.433044 1205.523438,578.530518   C1204.276123,579.487671 1203.290771,580.748230 1201.500000,580.500000  "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "line-95",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M683.000000,492.500000   C673.000000,506.666656 662.993042,520.828430 653.013550,535.009521   C652.243652,536.103577 651.666626,537.333313 651.000000,538.500000  "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "line-96",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M679.000000,725.500000   C686.708679,741.154419 698.570862,753.182434 711.949341,764.062256   C725.056824,774.721680 739.925476,781.964783 755.537781,787.900574   C756.861877,788.403992 757.498779,789.335205 758.500000,790.000000  "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "line-97",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1311.000000,376.000000   C1317.208496,377.856537 1317.805298,383.867615 1319.911255,388.539978   C1324.207886,398.072998 1327.994019,407.835815 1332.021118,417.491180   C1332.189087,417.893524 1332.666748,418.166656 1333.000000,418.499969  "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "line-98",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M611.500000,540.000000   C612.666626,549.166687 613.867859,558.329102 614.987610,567.501526   C615.711182,573.428589 618.203674,578.992615 618.500000,585.000000  "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "line-99",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1001.000000,633.750000   C1000.333313,633.666687 999.340332,633.257019 999.048706,633.548706   C994.282654,638.316284 987.822327,641.181335 983.993774,646.995911   C980.177917,652.791199 976.332947,658.577271 972.372742,664.259766   C969.986694,667.683472 967.486572,672.754639 967.363525,677.010498   C967.187134,683.114075 963.430481,686.554443 960.377014,690.402405   C953.776794,698.719666 945.948608,706.089111 939.616577,714.586853   C927.027893,731.481079 910.545898,744.560730 896.456970,759.960632   C894.797852,761.774109 893.927063,763.622375 894.000000,766.000000  "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "line-100",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M737.500000,362.000000   C732.564453,363.014587 731.214233,367.365143 728.970886,370.981934   C722.289856,381.753052 718.109497,393.719788 712.500000,405.000000  "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "line-101",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M898.500000,386.500000   C900.264038,387.214417 901.796143,387.822968 904.011719,387.669586   C914.809448,386.922058 925.496460,387.321106 935.554382,392.392181   C938.565613,393.910400 941.046997,395.855865 943.500000,398.000000  "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "line-102",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M877.000000,295.500000   C874.661438,295.151031 872.727234,296.025848 871.000977,297.501129   C860.838318,306.186005 851.493713,315.663849 842.952698,325.960754   C840.558899,328.846680 839.718689,331.928711 840.000000,335.500000  "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "line-103",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1251.000000,398.500000   C1247.162476,408.132507 1245.879150,418.315094 1245.080811,428.506317   C1244.061035,441.523407 1245.281860,454.393463 1248.953003,467.013672   C1250.814453,473.412811 1253.480469,479.379059 1257.000000,485.000000  "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "line-104",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1006.000000,548.500000   C1003.336853,550.946411 1002.389832,554.411377 1001.086853,557.536194   C996.905518,567.563904 991.279419,576.703979 985.015869,585.511292   C983.364624,587.833008 981.650879,589.921692 978.500000,590.000000  "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "line-105",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M726.500000,304.000000   C712.706848,315.756622 700.623596,329.164551 689.089172,343.073944   C687.998962,344.388702 686.868164,345.235107 685.500000,346.000000  "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "line-107",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M630.000000,382.500000   C622.638184,382.081299 616.541138,385.473633 610.502991,389.005157   C600.864563,394.642456 595.966003,404.397278 589.770203,413.014526   C588.726379,414.466278 590.068604,415.991547 590.000000,417.500000  "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "line-108",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M728.000000,697.000000   C735.333313,695.000000 742.945801,693.663147 749.890503,690.739807   C753.770508,689.106506 757.905396,686.843811 761.002258,683.502075   C764.690674,679.521851 771.577148,678.754150 772.199036,671.517090   C772.394043,669.247253 776.232910,670.325134 777.951294,669.177124   C782.633301,666.049377 786.632568,668.033264 791.049805,669.880981   C794.467102,671.310486 798.377808,671.509399 801.991211,672.531067   C810.910950,675.053101 818.453674,680.629639 827.000000,684.000000  "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "line-109",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1263.000000,495.000000   C1257.098267,500.675110 1252.371826,507.400208 1247.190796,513.657959   C1236.636108,526.406189 1222.362183,541.392090 1208.544067,552.057129   C1206.193604,553.871338 1203.834717,554.670776 1201.000000,554.500000  "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "line-110",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1177.500000,276.500000   C1177.582764,284.547394 1172.693115,290.736511 1169.397095,297.449463   C1166.738037,302.865326 1163.116455,307.803436 1160.014038,313.008392   C1156.902222,318.229248 1158.493408,321.916443 1164.508667,322.949371   C1169.800537,323.858093 1175.185425,324.211853 1180.495239,325.031036   C1186.964600,326.029175 1192.974365,328.331482 1199.085938,330.786011   C1210.198364,335.249023 1217.964600,342.999847 1224.518555,352.487213   C1224.874878,353.003082 1225.500000,353.333344 1226.000000,353.750000  "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "line-111",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M718.500000,579.000000   C721.936157,585.807617 722.016541,593.706177 725.497742,600.501160   C729.326233,607.973999 732.378845,615.721802 738.221802,622.249084   C741.165161,625.537170 743.567932,630.304260 743.283386,636.014099   C743.013428,641.433411 745.730713,646.883728 749.598694,650.905090   C753.626465,655.092590 758.072449,658.940430 763.465393,661.570923   C767.373169,663.477051 769.035156,667.964844 772.500000,670.500000  "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "line-112",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M600.000000,544.500000   C602.958374,556.062500 606.034790,567.591431 611.021790,578.490051   C612.462646,581.638794 612.953857,585.879456 618.000000,585.500000  "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "line-113",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M938.000000,689.000000   C930.089539,688.447693 923.007385,692.036438 915.503601,693.518188   C911.816162,694.246399 907.994934,694.738281 904.548096,696.119995   C901.077209,697.511414 898.373230,696.474426 895.500000,695.000000  "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "line-114",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M617.500000,586.500000   C619.031982,595.250549 623.521851,602.794800 627.572205,610.461853   C630.959106,616.873108 632.935852,624.220032 639.000000,629.000000   C638.833252,638.064148 647.407104,641.721252 651.122803,648.432007   C655.213440,655.819763 661.413086,661.613098 667.119446,667.848267   C672.819641,674.076599 679.161011,679.505737 685.024292,685.476135   C685.848511,686.315369 686.995728,687.401123 688.000671,687.408569   C694.953979,687.460693 700.289001,691.411621 706.007385,694.486267   C708.677368,695.921875 711.244263,696.273071 714.543091,695.801697   C718.159180,695.285034 722.162842,695.921448 726.000000,696.000000  "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "line-115",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M708.250000,653.000000   C715.906067,666.720215 722.224670,681.016418 727.045349,695.985413   C728.215027,699.617310 728.928223,703.206787 728.500000,707.000000  "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "line-116",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M798.500000,730.000000   C792.253296,737.411621 789.910522,746.595825 787.035522,755.511475   C785.365479,760.690430 784.192200,765.997192 785.500000,771.500000  "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "line-117",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M862.000000,282.000000   C858.955566,287.738708 853.043823,290.398315 848.437378,294.428406   C840.610962,301.275482 833.402344,308.730591 825.978577,315.978058   C824.528320,317.393890 823.459473,319.465881 821.000000,319.500000  "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "line-118",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M949.500000,483.500000   C948.500000,483.333344 947.114807,482.660065 946.561401,483.080811   C942.448181,486.207916 938.513245,483.831177 934.497375,483.012909   C924.726929,481.022095 914.800537,481.784668 905.013489,482.271240   C900.434692,482.498901 896.057129,483.273438 891.479614,482.078186   C888.513550,481.303741 886.164429,484.006744 883.020691,484.258453   C878.198547,484.644562 873.574646,486.471008 868.481689,485.607971   C864.707581,484.968384 861.798340,487.073792 860.005737,490.648499   C860.150818,494.385651 863.204163,494.757599 865.997620,495.508820   C873.337952,497.482697 880.651794,499.557800 888.011658,501.454712   C889.619080,501.868988 890.419128,503.046570 891.500000,504.000000  "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "line-119",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M720.500000,649.000000   C725.603577,660.241760 732.330872,670.495544 739.455200,680.531799   C741.873169,683.937988 745.263916,686.593750 747.000000,690.500000  "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "line-120",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1096.500000,664.500000   C1093.042603,664.228516 1090.094727,664.882874 1086.911987,666.858093   C1077.980591,672.401001 1068.658569,677.381226 1059.337158,682.184021   C1054.905396,684.467468 1050.999878,686.635254 1048.000000,690.500000  "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "line-121",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M702.000000,708.500000   C700.916748,711.466675 702.725586,713.592163 703.952026,716.024170   C711.661072,731.311646 717.356934,747.218811 718.604858,764.492432   C718.694031,765.726379 718.436035,766.544922 718.000000,767.500000  "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "line-122",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1152.000000,239.000000   C1144.412842,246.080551 1135.356201,251.286713 1127.552490,258.060486   C1122.400391,262.532776 1116.036133,265.869415 1113.000000,272.500000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-123",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15.5965,
    d: "m 1020.0991,358.88936 c -19.2892,4.68495 -31.84512,12.51577 -44.83938,20.32176 -11.20481,6.73096 -19.51698,14.33621 -30.92131,20.96291",
    style: {
      strokeWidth: 3.73004,
      strokeDasharray: "none",
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "line-124",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M921.000000,634.000000   C910.360596,640.787476 898.386902,644.295959 886.488831,647.963806   C884.408936,648.604919 882.292725,649.486267 880.000000,649.000000  "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "line-125",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M965.000000,218.500000   C963.581116,217.174011 961.817993,216.676544 960.006287,217.032104   C950.159729,218.964508 940.329163,220.979782 930.501465,223.007233   C924.127991,224.322083 921.515320,222.051422 922.014099,215.501068   C922.078186,214.659927 922.362976,213.838028 922.495667,212.999313   C925.468201,194.215332 920.140869,177.859406 908.000000,163.500000  "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "line-126",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M963.500000,207.500000   C951.904602,209.262527 940.334534,211.157394 929.001831,214.256775   C926.960144,214.815155 924.985107,214.440643 923.000000,214.000000  "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "line-127",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M974.000000,527.000000   C970.547729,527.018005 967.687988,527.173462 965.254517,530.836914   C963.343445,533.713928 960.330200,535.940979 955.558899,536.501343   C950.627441,537.080444 946.021240,541.455688 941.533875,544.549194   C934.674866,549.277588 927.762756,553.951294 921.434082,559.423767   C920.548035,560.189941 919.296448,562.019043 917.500000,560.500000  "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "line-128",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M834.500000,735.500000   C830.256714,732.717834 831.785828,728.333862 831.541199,724.497375   C831.339661,721.335999 831.500000,718.151672 831.500000,713.742981   C832.178467,712.399963 834.739685,712.325378 837.002258,711.758911   C846.481934,709.385620 855.699341,706.277771 864.496582,701.992981   C867.468811,700.545410 875.478210,703.541016 876.512390,706.495667   C877.071777,708.093933 875.699158,709.121155 875.465759,710.494202   C875.093750,712.682617 874.547363,714.845520 873.991211,716.997742   C872.175171,724.026428 868.961487,727.029663 861.494324,727.378479   C857.370544,727.571106 855.049255,728.720459 854.429199,732.989746   C854.151855,734.899536 853.280396,736.858887 851.489258,737.982910   C846.014343,741.418213 841.842163,746.377441 837.124939,750.638306   C824.987732,761.601440 811.585510,771.008789 799.526245,782.028748   C797.836304,783.573120 796.983582,783.914795 794.879150,782.143555   C792.172546,779.865417 790.142151,777.178467 788.000000,774.500000  "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "line-129",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1217.000000,464.500000   C1220.461060,467.274445 1219.297241,471.257538 1218.835327,474.476379   C1217.728271,482.193359 1216.712769,489.967194 1214.536987,497.510651   C1213.888672,499.757568 1213.590210,502.125488 1214.000000,504.500000  "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "line-130",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M833.000000,341.000000   C828.945557,347.643799 824.743164,354.163574 817.990967,358.485870   C817.560608,358.761322 816.956970,359.054230 816.506531,358.966553   C810.571960,357.811157 807.091553,361.868500 802.913940,364.880676   C800.101624,366.908447 797.930115,370.168457 794.003784,370.539825   C793.642090,370.574005 793.243713,371.114136 793.013123,371.507690   C788.336182,379.491455 779.641663,383.100250 773.473267,389.474152   C766.589783,396.586914 759.530029,403.530487 752.473389,410.472961   C751.142578,411.782257 750.541382,413.337799 750.000000,415.000000  "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "line-131",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1277.000000,360.500000   C1282.652100,371.140259 1287.156250,382.279877 1291.549561,393.480591   C1293.465820,398.366333 1297.819092,401.915802 1299.500000,407.000000  "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "line-132",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M976.000000,530.500000   C971.481934,536.604980 973.298462,543.391296 974.035645,549.996033   C975.060486,559.178528 976.315430,568.335693 977.529175,577.496155   C977.643433,578.358521 978.166626,579.166687 978.499939,580.000000  "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "line-133",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M961.500000,286.000000   C963.048340,296.627594 964.264465,307.320129 967.985352,317.505341   C969.018982,320.334808 969.894531,323.219421 972.000000,325.500000  "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "line-134",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M806.000000,427.000000   C798.658630,432.545990 791.881592,438.628876 788.539734,447.514923   C786.228149,453.661377 787.360352,460.707642 793.500000,465.000000  "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "line-135",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M774.500000,524.500000   C774.921082,518.868408 778.328430,514.434937 780.449341,509.478333   C781.604980,506.777710 783.344849,504.179871 782.978516,500.804565   C772.129150,497.948517 762.013794,493.095825 751.999329,488.001373   C748.824341,486.386230 745.965088,483.861664 742.000000,484.500000  "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "line-136",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M720.000000,571.500000   C720.199402,574.933044 718.749634,577.237244 716.105164,579.616882   C710.846924,584.348633 705.936401,589.939941 702.398499,595.742981   C698.105835,602.783875 692.521667,609.054382 689.091736,616.541992   C685.054138,625.356262 680.546814,633.944214 676.669250,642.856079   C673.926941,649.158813 674.317017,656.068665 671.054504,662.029846   C670.457031,663.121521 669.906616,664.159973 669.000000,665.000000  "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "line-137",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M997.000000,672.000000   C990.784729,678.795471 984.985840,685.691223 982.365295,694.961914   C979.883301,703.742249 974.693665,711.426636 970.528687,719.514771   C968.739319,722.989685 965.708496,726.066895 966.508850,730.498413   C966.682495,731.460083 966.082275,731.948059 965.502808,732.502930   C961.330811,736.497375 957.302246,740.656433 952.942871,744.434021   C950.757507,746.327759 948.762390,747.745728 947.759094,750.923950   C946.738525,754.157166 943.155884,756.138672 940.564148,758.568420   C937.185242,761.736328 933.159363,764.551086 932.035278,769.507996   C931.935608,769.947632 932.333313,770.500000 932.500000,771.000000  "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "line-138",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1297.000000,379.000000   C1293.636963,375.877808 1293.343384,371.155365 1291.003174,367.497955   C1289.257324,364.769073 1287.801514,361.994446 1284.542969,360.411469   C1279.187622,357.809845 1274.874023,360.016052 1271.062500,363.077850   C1263.462769,369.182892 1259.231445,377.719269 1255.498413,386.499298   C1254.008545,390.003632 1252.499878,393.499969 1250.999878,396.999969  "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "line-139",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M764.000000,458.000000   C765.865112,459.851624 765.256836,462.237915 765.564941,464.491119   C767.092712,475.664612 770.856201,485.930145 778.482300,494.515747   C779.116516,495.229797 779.500000,496.166656 780.000000,497.000000  "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "line-140",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1144.500000,207.000000   C1147.488647,210.197937 1151.835571,209.661789 1155.507324,210.979660   C1162.752686,213.580338 1170.382202,214.941544 1177.542725,217.896378   C1179.558105,218.727982 1181.416870,219.541306 1183.000000,221.000000  "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "line-141",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M1020.500000,665.500000   C1018.088623,669.747009 1019.338867,674.207764 1020.071838,678.487671   C1021.633972,687.609802 1019.236023,695.877747 1015.541626,704.018921   C1014.588440,706.119385 1012.545898,706.415710 1010.979553,707.469543   C1004.804443,711.624146 998.968811,716.250610 992.581360,720.133850   C989.651794,721.914856 987.226562,724.314941 983.500427,723.995178   C981.600525,723.832214 981.073547,725.583435 980.028442,726.531311   C976.309448,729.904602 971.978271,731.510193 967.000000,731.500000  "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "line-142",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M968.500000,240.000000   C964.882629,239.120560 961.978882,241.262100 959.035950,242.580231   C949.099548,247.030533 938.786804,250.798981 930.000000,257.500000  "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "line-143",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M1173.000000,696.000000   C1167.066650,700.093262 1159.689819,701.750549 1154.145386,706.181885   C1149.482666,709.908386 1144.516357,711.224548 1139.014526,712.092102   C1137.913940,712.265686 1136.894409,712.900513 1136.018677,711.982178   C1132.623657,708.422241 1128.257568,708.969604 1124.000000,709.000000  "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "line-144",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1083.500000,221.000000   C1080.920410,218.738632 1077.911621,218.152283 1074.508057,217.893448   C1067.840576,217.386429 1061.182007,216.895050 1054.500610,217.029663   C1049.164307,217.137146 1043.813965,218.258759 1038.504761,216.980057   C1031.508911,215.295105 1024.325073,214.401382 1017.500000,212.000000  "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "line-145",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1251.500000,217.500000   C1251.744995,218.486938 1251.251221,219.453369 1251.954590,220.529678   C1259.191040,231.604614 1258.001953,243.229355 1254.000000,255.000000  "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "line-146",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1210.500000,467.000000   C1208.008789,466.654541 1206.072876,467.538696 1204.489014,469.491089   C1196.590576,479.227203 1188.309692,488.595337 1178.538330,496.547089   C1177.747925,497.190338 1177.499878,498.499969 1176.999878,499.499969  "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "line-147",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M775.000000,590.000000   C779.088379,593.213623 779.976257,598.347534 782.497681,602.501404   C787.441467,610.645691 791.368103,619.450378 798.006714,626.493652   C800.713318,629.365234 799.844421,631.774475 798.154053,635.078796   C794.213684,642.781555 790.873962,650.806641 785.946106,657.962891   C784.119019,660.616211 781.335999,662.726440 783.000000,666.500000  "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "line-148",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M859.500000,491.500000   C844.307129,492.769348 830.560120,498.555878 816.968567,504.933044   C814.529724,506.077332 812.427185,507.093872 812.000000,510.000000  "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "line-149",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1270.000000,547.500000   C1270.990112,551.852478 1268.812622,555.366333 1267.011230,559.005554   C1263.473145,566.153381 1260.122803,573.398132 1256.402710,580.448669   C1255.599731,581.970642 1255.575928,583.092834 1256.000000,584.500000  "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "line-150",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M864.000000,342.000000   C858.101868,338.120636 852.806824,341.619171 847.529968,343.580566   C843.709656,345.000610 840.143494,347.122101 836.507202,349.013855   C833.507690,350.574402 830.468628,351.767792 827.000000,351.000000  "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "line-151",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1036.000000,739.000000   C1043.464233,747.543030 1052.130371,753.881531 1063.996704,754.557922   C1065.187988,754.625793 1066.290649,755.732483 1067.508057,755.956238   C1071.057739,756.608398 1074.686523,757.602600 1077.523193,754.018372   C1080.174683,750.668213 1084.240479,749.107300 1087.539429,746.550842   C1097.304199,738.983765 1101.927246,727.374146 1109.988525,718.489624   C1111.186279,717.169556 1110.227905,715.488281 1110.500000,714.000000  "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "line-152",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1259.500000,554.000000   C1258.333374,552.598938 1256.581543,553.759766 1256.088745,554.121033   C1249.794434,558.735718 1242.194702,561.915588 1238.496582,569.498352   C1237.549805,571.439453 1236.219604,572.585083 1234.096069,573.685486   C1228.872192,576.392334 1225.886108,581.788696 1222.149658,586.128906   C1216.253662,592.977783 1211.333374,600.666687 1206.000000,608.000000  "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "line-153",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1104.000000,278.000000   C1104.000000,279.166656 1103.562134,280.585205 1104.066406,281.461823   C1110.585815,292.796173 1113.221558,305.227448 1115.149658,317.977386   C1115.728149,321.802063 1115.632812,325.891418 1117.500000,329.500000  "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "line-154",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1188.000000,506.500000   C1180.114380,516.793701 1172.931152,527.613037 1164.578979,537.566223   C1163.086182,539.345154 1161.432739,540.499268 1159.500000,541.500000  "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "line-155",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M597.500000,505.500000   C596.084900,507.678802 596.140930,509.904816 596.369629,512.511414   C597.101990,520.859192 597.509338,529.227356 598.940796,537.510254   C599.223877,539.148499 599.342712,540.719116 600.500000,542.000000  "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "line-156",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M913.000000,650.500000   C909.718750,649.312378 906.923706,651.120056 904.005310,652.017273   C895.490295,654.635132 886.986694,657.292603 878.521118,660.064392   C877.696533,660.334412 877.166687,660.752136 876.500000,660.000000  "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "line-157",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1079.000000,430.500000   C1080.321167,433.363129 1080.516602,436.407806 1080.507202,439.500031   C1080.484863,446.833282 1080.531128,454.166870 1080.479614,461.499847   C1080.465454,463.510895 1080.524414,465.432739 1082.000000,467.000000  "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "line-158",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 793.27324,464.44375 c 9.01135,5.94192 38.80861,20.44416 48.74049,24.01804 2.15473,0.77533 4.3562,1.26639 5.48627,3.53821"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "line-159",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1234.000000,295.500000   C1224.289551,307.088867 1215.003418,319.050903 1204.022339,329.523407   C1203.514893,330.007446 1203.333374,330.833374 1203.000122,331.500061  "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "line-160",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M981.000000,408.500000   C986.792480,410.416138 986.481812,416.528046 988.745667,420.640015   C992.214172,426.940155 993.954651,434.183777 996.524719,440.990662   C997.427612,443.382141 997.819336,445.666656 996.500000,448.000000  "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "line-161",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1006.000000,697.000000   C1000.260803,694.492065 993.481750,696.019897 988.097473,693.306580   C980.040100,689.246277 975.643921,693.707092 970.432739,698.425720   C961.847412,706.199585 952.890259,713.569641 943.920044,720.902161   C942.920288,721.719360 942.622864,722.631653 942.000000,723.500000  "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "line-162",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M909.500000,344.500000   C911.423096,346.707886 910.377441,349.281311 909.899292,351.478088   C908.520081,357.815704 907.102905,364.156403 904.065002,370.033600   C902.133606,373.770386 902.730591,378.333862 900.087219,382.061829   C896.637451,386.927032 892.436707,390.802094 887.671326,394.216278   C883.904297,392.272675 880.557739,392.252533 876.438721,393.246063   C869.387878,394.946716 862.950195,398.179810 856.042542,400.149200   C854.260254,400.657318 852.265564,402.265533 851.500000,404.500000  "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "line-163",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1030.500000,563.000000   C1026.776245,570.792053 1025.309326,579.280273 1023.070312,587.519104   C1022.062439,591.227539 1019.389709,594.826172 1021.500000,599.000000  "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "line-164",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M805.250000,300.000000   C808.704407,304.751129 813.959656,307.830109 817.033630,312.979919   C821.777649,320.927643 823.479370,329.403168 821.969055,338.494873   C821.462708,341.543304 814.642822,345.693756 810.503052,346.036499   C804.447021,346.537842 798.754883,346.755310 792.870117,343.754669   C788.904846,341.732758 783.669983,343.009033 778.967346,342.186646   C770.469360,340.700531 762.628662,337.780640 755.000000,334.000000  "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "line-165",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1142.000000,229.000000   C1144.561768,226.961273 1147.397339,226.479263 1150.500122,227.499527   C1154.656128,228.866074 1159.536621,227.954071 1163.021729,231.478561   C1163.186523,231.645248 1163.708008,231.601669 1163.993896,231.485153   C1171.244873,228.529816 1176.913208,234.237503 1183.444214,235.332474   C1190.210571,236.466843 1196.490723,240.484818 1203.068604,242.805481   C1216.127197,247.412476 1227.330322,255.339340 1239.489502,261.520660   C1242.966064,263.288086 1245.264404,269.995239 1244.568970,274.011932   C1243.463745,280.395233 1241.496094,286.331787 1237.500000,291.500000  "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "line-166",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M638.500000,634.000000   C633.103760,634.787720 630.900330,639.428406 628.067566,643.052795   C621.685669,651.217896 615.692017,659.685669 609.473877,667.980408   C608.494202,669.287231 607.166626,670.333313 606.000000,671.500000  "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "line-167",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1240.000000,505.500000   C1230.549194,515.110229 1221.033691,524.633484 1210.055542,532.576721   C1208.256836,533.878235 1206.617554,534.614929 1204.500000,534.500000  "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "line-168",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M673.500000,389.500000   C671.983276,393.441681 673.962402,396.965637 675.068298,400.478516   C677.425110,407.965088 680.823730,414.929443 685.881348,421.097290   C687.127136,422.616516 688.191284,422.331482 689.500000,422.500000  "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "line-169",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1311.000000,388.000000   C1313.438232,389.716980 1313.268311,392.622711 1313.902100,395.025818   C1314.931763,398.930084 1315.543213,402.979889 1315.929077,407.006805   C1316.203979,409.877411 1316.944946,412.904633 1314.588379,415.577881   C1313.854126,416.410919 1313.982788,418.173218 1314.030029,419.498932   C1314.325806,427.789001 1312.455811,435.845215 1311.578857,444.008453   C1311.355835,446.083282 1310.237549,447.224548 1309.000000,448.500000  "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "line-170",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M876.500000,839.500000   C875.096252,844.922852 869.763184,845.574402 865.945679,847.911255   C861.511963,850.625183 856.751160,852.864014 851.963013,854.913635   C849.698547,855.882996 846.750305,857.242126 844.601379,855.382874   C842.575623,853.630127 844.456848,851.141357 844.983032,848.995850   C845.098755,848.524231 845.000000,848.000000 845.000000,847.500000  "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "line-171",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1103.500000,281.000000   C1097.135010,286.953064 1089.947021,292.137177 1086.922485,300.973450   C1085.375854,305.491730 1081.168457,308.299072 1077.859131,311.347015   C1070.970337,317.691742 1064.850342,324.633270 1060.194702,332.613617   C1058.073608,336.249512 1054.111450,336.658966 1051.849487,339.894806   C1047.959595,345.459564 1044.734131,351.533875 1040.000000,356.500000  "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "line-172",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M774.000000,525.500000   C770.833191,532.903076 764.760010,537.297668 758.003357,541.006042   C752.631409,543.954407 747.926392,547.877686 743.587830,552.090454   C740.053528,555.522217 736.393738,558.917114 733.070496,562.613892   C729.226196,566.890259 723.563477,571.436584 716.506470,570.912903   C714.868286,570.791382 713.694702,571.563721 712.538635,572.085632   C699.084045,578.160522 686.821960,586.378357 675.197815,595.258972   C669.396973,599.690674 663.331665,604.354065 658.586731,610.071960   C653.115906,616.664612 646.463440,621.963440 640.500000,628.000000  "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "line-173",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M657.000000,614.500000   C660.333374,622.833313 663.637878,631.178406 667.014160,639.494263   C668.363464,642.817566 669.636597,646.200012 672.000000,649.000000  "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "line-174",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M978.000000,275.000000   C969.004028,272.394531 959.783447,271.013062 950.497314,270.025330   C948.850708,269.850159 947.009155,269.733246 946.016846,271.509399   C943.610352,275.816498 939.065186,277.609589 935.417664,280.392090   C933.009460,282.229309 930.404846,283.733978 929.052246,286.525330   C928.562073,287.536957 927.969055,287.705597 927.023682,288.062683   C919.174927,291.027771 913.507141,297.186310 907.671143,302.681732   C901.091858,308.876984 893.320068,313.900085 888.281250,321.861542   C886.723694,324.322357 882.570007,325.140045 879.723511,326.647339   C872.930237,322.169403 872.065430,320.192200 875.070007,313.531586   C877.331665,308.517914 878.750427,303.589722 878.087463,297.989655   C877.579041,293.694580 879.409241,289.591919 880.589355,285.525940   C881.396851,282.743835 881.586121,280.795532 878.515930,279.463257   C875.928040,278.340332 875.527649,276.512451 875.778503,273.481659   C876.147522,269.022491 872.892517,265.208344 871.456238,261.014984   C869.728394,255.970413 865.451111,252.228577 864.000000,247.000000  "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "line-175",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M788.500000,560.500000   C793.510803,552.512390 799.763550,545.508423 806.017395,538.515564   C809.337952,534.802673 813.263611,531.670166 815.597107,527.049072   C816.637512,524.988831 819.606079,523.739685 821.461731,524.166382   C832.206726,526.637207 842.833130,523.483459 853.500305,523.993652   C854.498047,524.041382 855.500000,524.000000 856.500000,524.000000  "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "line-176",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M858.000000,733.000000   C859.439148,735.294006 860.018433,737.725037 860.067688,740.498779   C860.232605,749.790710 862.565125,758.700562 867.677368,766.381958   C870.388733,770.455872 874.099915,774.337646 880.547668,773.294495   C882.440430,772.988220 883.724121,772.675110 885.000183,771.500244   C891.916199,765.132935 892.451294,765.203491 900.047363,769.923767   C902.492310,771.442993 905.603638,772.531860 908.467468,771.861206   C911.033813,771.260132 913.139404,771.660645 914.958862,773.053772   C918.306946,775.617249 921.533386,775.087708 925.014648,773.532776   C927.270142,772.525208 929.666626,771.833252 932.000000,770.999939  "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "line-177",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M880.000000,811.500000   C870.075195,820.241882 861.086548,829.924194 852.080688,839.575256   C850.917297,840.822083 848.935120,842.134216 849.500000,844.500000  "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "line-178",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M960.000000,550.500000   C963.166626,558.166687 966.123352,565.930115 969.592346,573.457458   C971.222107,576.993774 971.945435,581.470032 976.500000,583.000000  "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "line-179",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M721.000000,772.500000   C719.690979,774.516541 720.009033,776.785767 720.003296,779.000000   C719.992126,783.333313 720.292847,787.691223 719.932251,791.994324   C719.375793,798.635620 720.895142,804.841125 723.000000,811.000000  "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "line-180",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1113.500000,369.500000   C1105.490601,374.322357 1099.751709,381.798950 1092.485840,387.481934   C1085.944580,392.598053 1081.025024,399.751984 1072.461548,402.893372   C1077.168823,410.655792 1076.593384,419.763947 1080.500000,427.500000  "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "line-181",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M912.000000,341.000000   C910.965637,343.069977 909.146118,343.823486 907.023438,344.566986   C897.469666,347.913391 887.996338,351.490143 878.504211,355.011322   C877.171387,355.505737 876.076477,356.194977 876.485168,358.003357   C878.517517,366.996033 880.434875,376.015320 882.545776,384.989227   C883.072449,387.228058 884.166626,389.333344 884.999939,391.500031  "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "line-182",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1146.500000,158.000000   C1146.198120,155.583206 1144.060303,154.553314 1142.446899,153.588928   C1134.778320,149.005081 1126.427734,144.361633 1117.946777,143.570709   C1110.067871,142.835922 1102.535767,139.431000 1094.500000,140.500000  "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "line-183",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1079.000000,470.500000   C1076.302734,469.353485 1074.031250,470.040497 1071.455811,471.417297   C1062.901245,475.990448 1055.199951,482.108337 1046.000000,485.500000  "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "line-184",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M767.500000,438.000000   C765.618835,437.260834 764.222473,438.033539 762.446777,438.889618   C754.146423,442.891174 746.569397,448.121216 738.520203,452.536865   C734.625183,454.673615 734.226379,457.016815 735.442383,461.515594   C737.330139,468.499512 739.048401,475.530670 740.885925,482.529968   C743.593994,492.845764 747.068848,502.821625 751.461121,512.517639   C752.235291,514.226746 752.500000,516.166687 753.000000,518.000000  "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "line-185",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M920.500000,226.500000   C916.156555,226.449402 911.601868,225.909714 908.062683,229.070160   C906.333801,230.614044 904.475830,230.577774 902.529846,231.109283   C896.282898,232.815491 889.963989,234.544662 884.074280,237.166809   C880.401245,238.802063 876.724060,240.977859 873.226868,243.035904   C868.876892,245.595886 862.880737,247.511124 856.970825,245.070587   C852.638245,243.281418 851.466797,243.997421 850.562500,248.512512   C849.890625,251.867188 848.350403,253.551743 845.105042,255.206085   C838.259766,258.695435 832.004639,263.340607 825.498108,267.497040   C822.177673,269.618103 818.716370,270.438324 815.000000,268.500000  "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "line-186",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M847.500000,429.000000   C845.048279,425.868042 841.091309,425.129669 837.965210,423.052307   C834.423157,420.698486 830.922485,418.436584 828.187012,415.050903   C826.658447,413.158997 824.571533,412.121857 821.973877,413.963135   C818.242981,416.607666 814.254761,418.889648 810.529541,421.541473   C808.309448,423.121857 807.397827,425.326080 808.992371,428.004547   C810.524475,430.578156 809.474548,432.481110 808.171448,435.085785   C802.965881,445.490601 797.990540,456.004669 793.794800,466.921143   C790.711914,474.942291 787.426697,482.900940 784.369385,490.950378   C783.230774,493.948029 782.313660,496.855652 782.000000,500.000000  "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "line-187",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M878.000000,726.500000   C881.876770,738.050415 886.876526,749.047974 894.000000,759.000000  "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "line-188",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1123.000000,518.500000   C1113.108643,513.090454 1102.921997,508.585388 1091.502808,507.470856   C1084.005371,506.739014 1077.236572,503.623596 1070.500000,500.500000  "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "line-189",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1296.000000,412.500000   C1294.144531,414.072235 1293.615479,416.237274 1292.933228,418.479706   C1290.796143,425.504028 1288.250000,432.381958 1285.090698,439.042999   C1284.159058,441.007080 1282.959351,442.538177 1281.500000,444.000000  "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "line-190",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M966.000000,782.500000   C969.297241,789.699280 964.149780,794.767273 961.531006,800.514160   C959.426697,805.131958 954.974365,808.750916 955.500000,814.500000  "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "line-191",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M963.500000,283.500000   C960.747131,287.114929 956.493347,285.498322 952.981995,286.432312   C946.461304,288.166656 939.684387,288.037994 932.996399,288.440704   C931.687927,288.519470 930.333313,287.833344 929.000000,287.500000  "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "line-192",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1317.000000,413.500000   C1318.490845,414.837921 1319.220947,416.343781 1319.622070,418.477051   C1321.087158,426.269623 1321.871094,434.121857 1322.456299,442.003235   C1322.563477,443.446442 1322.963745,444.563141 1324.000000,445.500000  "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "line-193",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1182.000000,643.000000   C1180.132202,639.078186 1181.134888,635.263733 1182.515747,631.505798   C1183.797729,628.017395 1186.427002,626.825256 1190.963379,628.593811   C1196.107544,630.599487 1199.773193,629.035095 1203.567139,625.573608   C1207.057129,622.389343 1209.893555,619.323608 1211.798828,614.621033   C1214.263672,608.537109 1220.317383,604.651367 1225.073486,600.076416   C1226.342041,598.856201 1228.450684,599.160034 1229.929932,600.274536   C1230.619873,603.833740 1227.894043,605.741577 1226.369141,607.907837   C1223.948730,611.346191 1222.364136,614.716553 1222.403320,619.000854   C1222.421753,621.036499 1222.134766,623.252014 1220.583984,625.071533   C1220.126099,625.608582 1219.155273,626.311462 1219.479248,627.505615   C1221.271362,634.111572 1216.780151,638.441833 1213.396240,642.921631   C1210.994141,646.101379 1206.708252,647.127808 1203.384033,649.324585   C1197.635376,653.123596 1191.130737,655.766541 1185.023071,659.043030   C1183.308838,659.962646 1181.761353,660.279663 1180.000000,659.500000  "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "line-194",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M910.500000,269.000000   C911.864746,270.506348 913.431030,270.712341 915.505371,270.595551   C922.824890,270.183350 930.166138,270.126129 937.500366,270.029388   C939.265991,270.006042 940.952332,269.928436 942.500000,269.000000  "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "line-195",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M773.000000,686.500000   C777.666626,695.666687 782.363281,704.818298 786.963440,714.018250   C787.563416,715.218262 787.666687,716.666626 788.000061,718.000000  "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "line-196",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1203.000000,530.500000   C1199.523438,526.656250 1200.699829,520.744507 1196.893921,517.185181   C1187.030151,526.865723 1176.110229,535.782166 1167.439453,546.953003   C1165.681641,549.217468 1162.877686,550.374817 1160.000000,551.000000  "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "line-197",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M1072.500000,404.000000   C1064.361816,410.430389 1056.576538,417.364929 1047.456787,422.421997   C1045.221802,423.661377 1044.631348,425.839020 1044.178101,427.547241   C1043.161377,431.378448 1041.072388,432.501923 1037.499268,432.005371   C1031.768188,431.208923 1027.254395,432.684326 1023.867798,437.914398   C1022.116272,440.619202 1019.606934,443.149292 1016.015503,444.061096   C1013.966614,444.581299 1012.924866,446.507812 1013.053528,448.496521   C1013.593384,456.838074 1014.263428,465.173248 1015.046997,473.495575   C1015.253723,475.691589 1015.738953,477.785522 1015.109009,480.030579   C1014.931396,480.663727 1013.912903,481.446838 1014.960632,482.537781   C1019.642090,487.412476 1016.356323,493.986328 1018.349487,499.553894   C1019.185730,501.889832 1019.015015,504.671021 1021.535156,505.929657   C1023.184387,506.753296 1023.357483,508.171295 1024.020386,509.489746   C1027.510498,516.431885 1029.865845,523.817505 1035.168335,530.032898   C1037.496216,532.761475 1040.440430,538.115784 1036.124268,543.107422   C1033.608276,546.017212 1032.306641,549.986389 1030.512939,553.506592   C1029.768677,554.967041 1029.166626,556.500000 1028.500000,558.000000  "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "line-198",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1203.500000,194.500000   C1205.232666,192.630493 1204.339355,190.238037 1203.853271,188.542038   C1202.055786,182.269608 1199.991577,176.023026 1197.356567,170.063400   C1196.123535,167.274353 1193.272827,164.773788 1189.994507,164.607162   C1181.853760,164.193451 1174.164062,161.199768 1166.005493,160.866714   C1163.556274,160.766724 1161.268555,160.426544 1159.000000,161.500000  "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "line-199",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M808.000000,423.500000   C807.000000,423.166656 805.979065,422.885223 805.003418,422.491577   C798.399475,419.827118 792.986206,422.589600 789.898743,428.950867   C784.404480,440.271271 776.906128,449.801483 764.548340,454.623810   C761.556763,455.791168 758.943909,458.266846 756.550781,460.553223   C752.695435,464.236664 748.679504,467.689941 744.571838,471.086884   C741.227844,473.852264 737.450073,475.306030 733.520813,474.828705   C729.105591,474.292358 725.329346,475.137207 721.472839,476.941986   C720.315063,477.483765 718.832520,477.482178 717.500122,477.475220   C710.159119,477.436890 703.329651,479.705048 696.500000,482.000000  "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "line-200",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1140.000000,507.500000   C1142.779175,507.880096 1145.158936,506.658600 1147.488281,505.476776   C1152.876831,502.742737 1158.880127,501.980011 1164.515381,500.044769   C1165.071899,499.853668 1165.842896,500.287140 1167.221069,500.581848   C1165.903931,505.639496 1164.888916,510.595764 1159.488281,512.973450   C1156.445679,514.312927 1154.092285,516.573975 1151.519409,518.525574   C1139.091064,527.953003 1126.234863,536.746704 1113.030396,545.048401   C1111.403931,546.070984 1109.825195,546.528564 1108.000000,546.500000  "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "line-202",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M715.500000,275.500000   C715.760315,277.540680 715.040161,279.330872 713.991699,280.994781   C709.678101,287.840515 704.464417,294.291046 701.293335,301.626801   C699.029846,306.863007 696.362915,311.532318 693.052795,316.038757   C691.829529,317.704071 690.533813,318.800751 688.500000,319.000000  "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "line-203",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M751.000000,520.000000   C729.657898,515.120056 708.803467,509.045929 690.704163,496.569855   C692.851746,491.174469 695.705566,487.272858 696.660645,482.066101   C689.214539,479.953979 681.948792,477.281708 674.000000,479.000000  "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "line-204",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1035.500000,217.500000   C1032.804688,222.677368 1027.370483,222.110779 1022.970154,222.812973   C1017.200439,223.733704 1011.730469,226.441986 1005.449707,225.269318   C1003.115112,224.833435 999.912292,227.681320 998.656799,230.081985   C996.308655,234.571869 993.095032,238.598206 991.439270,243.479401   C990.902893,245.060577 990.635864,246.617142 989.127441,248.127304   C982.348511,254.914200 981.816833,264.591736 978.545898,273.017822   C977.769836,275.017151 979.812805,276.341553 980.351196,277.667572   C979.171753,281.347870 975.766052,283.007843 974.000000,286.000000  "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "line-205",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1312.000000,474.500000   C1309.464111,472.230499 1310.874512,468.335999 1308.406006,465.909302   C1306.157227,466.304260 1305.661255,468.170593 1304.980957,469.992889   C1302.361084,477.010345 1299.729858,484.025238 1296.956055,490.982513   C1296.245239,492.765350 1296.500610,494.333344 1297.000000,496.000000  "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "line-206",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M644.500000,541.500000   C643.877991,549.519165 639.902222,556.130920 635.465332,562.475769   C631.850098,567.645508 628.627625,573.033875 625.460999,578.477295   C623.702942,581.499329 621.445190,584.179321 618.000000,585.500000  "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "line-207",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1302.000000,368.500000   C1298.892578,375.342712 1297.378174,382.457245 1298.240234,390.001129   C1298.612305,393.257294 1299.184204,396.565918 1297.000000,399.500000  "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "line-208",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M731.500000,711.500000   C730.656616,713.271790 730.761597,715.218689 731.054688,716.990967   C733.505127,731.813416 732.758667,746.641663 731.557922,761.504700   C731.184387,766.128662 731.698059,770.845337 729.000000,775.000000  "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "line-209",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1297.500000,434.000000   C1295.515991,435.566193 1294.340820,437.505005 1293.378052,439.952026   C1291.090088,445.767700 1288.231689,451.365295 1285.466187,456.983368   C1284.440796,459.066467 1282.723999,461.144775 1280.486206,461.348694   C1277.825806,461.591064 1277.470947,463.796051 1276.000000,465.000000  "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "line-210",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1189.000000,504.500000   C1192.861328,499.688812 1196.337280,494.536346 1200.084473,489.679443   C1204.877563,483.466949 1209.752563,476.380402 1210.917114,467.988495   C1211.106934,466.620117 1211.753906,465.909424 1212.482422,464.986115   C1219.146606,456.538910 1219.649170,446.792725 1215.747925,437.607056   C1211.968750,428.708893 1208.234985,427.659241 1198.497925,430.493042   C1197.179321,430.876831 1195.833374,431.166656 1194.500000,431.500000  "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "line-211",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M956.000000,633.500000   C951.563599,632.188232 948.271057,635.205750 944.484436,636.452698   C938.063660,638.567017 932.218201,642.211243 925.500000,643.500000  "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "line-212",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1009.000000,548.500000   C1009.192261,554.923767 1007.613525,561.160950 1006.955261,567.495361   C1006.608459,570.833313 1005.572754,574.042175 1006.385193,577.526733   C1006.736572,579.033813 1006.269470,581.112122 1005.416382,582.446533   C1003.064758,586.124817 1000.705261,589.735046 999.471436,593.991699   C998.776794,596.387939 996.081177,596.648376 994.586731,598.089905   C991.515015,601.052795 988.321594,603.839783 985.000000,606.500000  "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "line-213",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1119.500000,649.500000   C1122.084961,651.734009 1125.645752,651.054260 1128.592041,652.848877   C1134.424438,656.401489 1135.724609,660.182495 1131.458496,665.466492   C1129.021362,668.485107 1126.170532,671.170288 1123.498535,673.998535   C1122.084961,675.494568 1120.288208,676.718384 1120.000000,679.000000  "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "line-214",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M956.500000,336.000000   C951.410034,333.467010 946.466125,336.104034 941.510803,336.606628   C936.373291,337.127716 931.287231,337.655243 926.347961,340.205505   C923.520996,341.665192 919.126465,339.748901 915.509338,340.097076   C909.975342,340.629791 909.342651,336.253662 907.508728,332.995087   C904.839966,328.253387 900.799194,325.530457 895.504089,324.479309   C893.281677,324.038116 890.925415,323.950714 889.000000,322.500000  "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "line-215",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M878.000000,334.500000   C879.000000,334.833344 880.031250,335.527405 880.995117,335.443878   C890.048218,334.659271 898.993713,336.335663 908.000000,336.500000  "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "line-216",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1080.000000,480.000000   C1086.079224,487.797150 1090.129395,496.376556 1089.969604,506.499512   C1089.931030,508.949402 1091.077148,510.879120 1091.939697,513.024231   C1095.809692,522.648865 1097.761719,532.611816 1095.946289,542.990601   C1095.468994,545.719543 1094.333374,548.333374 1093.500122,551.000000  "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "line-217",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1203.500000,531.500000   C1203.666748,532.833313 1204.438965,534.519836 1203.901001,535.442322   C1200.579956,541.137512 1201.036011,547.343323 1201.014526,553.500061   C1201.007812,555.407776 1199.498413,556.255920 1198.516968,557.513245   C1195.735962,561.076172 1191.224121,562.890808 1188.980103,567.036865   C1190.155273,569.749268 1191.000122,571.825562 1188.737793,575.161255   C1184.921753,580.787720 1181.880127,587.166687 1180.571777,594.013733   C1179.851807,597.782166 1177.447266,599.790955 1174.486328,601.476074   C1172.838379,602.413940 1171.201660,603.125671 1172.483521,605.508850   C1173.665771,607.706726 1172.488037,609.474487 1171.589233,611.538879   C1168.222534,619.271057 1163.149658,626.171631 1160.823120,634.450317   C1160.224731,636.579285 1157.602051,638.302795 1155.000000,639.000000  "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "line-218",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M689.000000,622.000000   C694.333313,630.500000 699.650696,639.010071 705.015747,647.490051   C705.903992,648.894104 707.000000,650.166687 708.000000,651.500000  "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "line-219",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M979.500000,409.000000   C975.191711,422.158661 973.818115,435.814972 972.437683,449.493713   C971.848694,455.330933 972.526184,461.313354 970.525208,467.008881   C970.008240,468.480621 971.452820,469.353546 972.000000,470.500000  "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "line-220",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1275.500000,582.500000   C1277.170898,575.241516 1280.938599,568.612732 1281.571899,561.005981   C1282.081055,554.891418 1280.516968,551.066040 1275.500000,548.499939   C1269.871338,545.620911 1262.513306,547.556885 1260.275024,554.094177   C1258.082764,560.497803 1253.618652,564.966797 1249.786499,569.831848   C1246.059692,574.563049 1242.679810,579.599609 1237.338379,583.467224   C1232.949341,586.645203 1229.973999,593.179321 1229.000000,599.500000  "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "line-221",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1048.000000,623.000000   C1047.963257,624.654419 1048.029175,626.099121 1046.565308,627.565186   C1041.068970,633.069092 1035.697998,638.714233 1030.561646,644.554199   C1028.258301,647.172974 1025.640015,647.762207 1022.500000,647.500000  "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "line-222",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1054.000000,370.000000   C1060.318481,377.702850 1065.758789,385.965240 1070.009888,394.995361   C1071.120605,397.354767 1070.920532,400.373047 1073.500000,402.000000  "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "line-223",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M857.000000,636.000000   C851.084778,640.761902 847.691406,646.922302 849.181519,654.464111   C850.090027,659.062317 847.645569,661.847473 845.362000,664.375305   C841.596924,668.543274 837.048218,671.961548 834.966614,677.487427   C833.996582,680.062439 832.254089,682.025146 829.518616,683.049683   C828.444092,683.452148 827.665283,684.217773 826.864380,685.408813   C820.441833,694.958923 812.291687,703.312744 807.404480,713.956116   C806.737549,715.408630 804.778809,716.267883 803.295898,717.503784   C799.666687,714.753235 795.843628,716.466675 791.997803,717.491821   C784.424255,719.510437 777.716431,718.462952 771.934326,712.564392   C768.802856,709.369812 765.000000,706.833374 761.500000,704.000000  "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "line-224",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1031.500000,629.500000   C1036.164551,631.494690 1038.207275,626.944702 1041.510864,625.525269   C1051.051392,621.426086 1057.358521,613.469055 1063.913330,606.159119   C1068.175171,608.636292 1068.273926,612.652710 1068.868164,616.023254   C1070.055420,622.758179 1070.317871,629.636902 1069.960083,636.497925   C1069.933105,637.013794 1070.736450,637.253601 1070.046021,638.040344   C1065.874756,642.793640 1068.335571,649.550903 1065.691772,654.329407   C1063.512695,658.267822 1062.918457,663.351624 1057.160156,665.866760   C1050.951904,668.578491 1045.970215,674.129517 1040.509033,678.511169   C1035.798828,682.290222 1031.096191,686.085388 1026.534180,690.039429   C1024.666870,691.657898 1022.330261,690.321045 1020.500000,691.500000  "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "line-225",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1272.000000,463.000000   C1268.125000,459.851410 1266.644165,454.835632 1263.005615,451.493896   C1259.062622,447.872528 1255.472534,443.904541 1249.519165,443.308777   C1248.057373,443.162537 1246.833374,443.975037 1245.500000,443.500000  "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "line-226",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M786.000000,523.000000   C789.222534,525.123230 792.880127,524.852844 796.498352,525.032898   C802.842773,525.348572 809.338074,523.828674 815.500000,526.500000  "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "line-227",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M741.000000,485.000000   C739.085144,486.085144 737.425049,487.512787 736.525513,489.511475   C729.921631,504.183350 723.504761,518.823608 720.769531,534.960938   C719.184692,544.310730 718.050598,553.557678 717.954773,562.999512   C717.925537,565.887146 718.453918,568.404236 720.500000,570.500000  "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "line-228",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 1180.7103,220.08281 c 8.8363,3.16066 43.0647,17.53267 51.3015,21.89474 1.2482,0.66097 2.6548,1.02243 3.9882,1.52243"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "line-229",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1268.500000,221.999985   C1267.666626,222.166656 1266.484619,222.774612 1266.052734,222.433319   C1260.273315,217.866013 1252.800415,217.351700 1246.455078,214.087387   C1239.019165,210.262024 1230.949097,208.511017 1222.500000,209.000000  "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "line-230",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M970.500000,665.500000   C967.662903,665.231628 965.242249,665.586792 964.451965,668.988831   C964.279541,669.731567 963.626160,670.508728 962.980652,670.973083   C956.038696,675.966675 951.918152,684.685669 942.967468,686.866455   C938.947327,687.846008 938.191589,691.531311 935.651672,693.679321   C928.036377,700.119934 918.558960,703.867310 911.474426,710.974548   C910.413696,712.038696 908.461487,711.963440 907.561768,711.401184   C902.279968,708.100220 896.221619,707.024231 890.513733,704.961975   C889.911682,704.744507 889.500000,704.000000 889.000000,703.500000  "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "line-231",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m 1039,539 c 3.4973,0.75342 5.0016,3.99817 7.4952,6.00586 6.5218,5.25055 10.1777,13.06842 16.5147,18.48254 1.2646,1.08045 2.8689,1.82465 3.9475,3.04908 2.5332,2.87554 5.4543,3.2536 9.0563,2.53064 5.2015,-1.04383 6.9575,1.22454 6.0368,6.44079 -1.681,9.52356 -10.6571,23.434 -17.0819,30.1616"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "line-232",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1197.000000,599.000000   C1193.024902,601.617371 1193.504517,606.308838 1192.130737,610.048035   C1190.007446,615.826904 1186.542114,621.166809 1186.000000,627.500000  "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "line-233",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1167.500000,274.499969   C1175.500000,274.999969 1183.568604,275.019440 1191.478760,276.148499   C1198.082153,277.091064 1204.569702,279.108276 1210.971802,281.090881   C1214.393433,282.150513 1217.617065,282.324890 1221.000000,281.500000  "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "line-234",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M731.000000,777.500000   C727.894531,784.862488 727.737793,792.926270 725.549194,800.514160   C724.935669,802.641174 724.179138,804.537109 722.500000,806.000000  "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "line-235",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1154.000000,639.000000   C1144.029297,642.066589 1133.967407,644.903381 1125.000000,650.500000  "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "line-236",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M833.000000,682.500000   C835.142395,687.972168 840.640076,688.185608 845.028137,689.929199   C851.586548,692.535156 858.333313,694.666687 865.000000,697.000000  "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "line-238",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1268.500000,499.000000   C1273.822632,503.105103 1279.855225,504.654510 1287.484253,503.228455   C1285.631592,509.234009 1286.406494,514.424133 1283.250000,519.650940   C1278.153564,528.089539 1274.666626,537.500000 1270.500000,546.500000  "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "line-240",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1109.500000,396.000000   C1102.542969,395.507568 1096.206055,398.539642 1089.511719,399.576019   C1086.545288,400.035278 1083.776611,400.131805 1081.000000,399.000000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-241",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m 749.5,522 c -7.65997,5.69318 -15.91998,10.45612 -23.95758,15.56677 -1.49176,0.94849 -5.21264,4.62448 -6.89672,4.57229",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "line-242",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M906.500000,712.000000   C898.292969,718.085938 888.458984,720.917358 879.468262,725.436829   C877.062683,726.646118 875.095276,724.398743 873.000000,723.500000  "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "line-243",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.29811,
    d: "m 944.4892,401.68045 c 0.0378,9.11955 -3.82705,22.06559 -4.31008,31.12526 -0.20303,3.80735 -0.66505,7.91684 0.7581,11.54665"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "line-244",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M647.500000,581.000000   C649.833313,588.666687 652.261536,596.306580 654.435852,604.018066   C655.007080,606.043945 655.837341,607.816345 657.000000,609.500000  "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "line-245",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1155.500000,671.500000   C1157.131226,680.337463 1149.877686,684.892090 1145.922729,690.949524   C1141.910156,697.095337 1137.700073,703.184387 1132.000000,708.000000  "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "line-246",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1212.500000,645.000000   C1213.388916,653.123352 1208.889526,660.947754 1202.049072,664.592041   C1197.332764,667.104675 1193.179688,670.604309 1188.941162,673.924927   C1184.880371,677.106140 1180.297852,679.614075 1176.010132,682.514954   C1171.876099,685.312012 1170.549927,690.818542 1173.000000,694.499939   C1174.809937,697.219482 1183.264282,699.332581 1186.457764,697.429138   C1190.139648,695.234375 1193.626221,692.654846 1196.953491,689.942993   C1199.012207,688.265076 1199.964355,686.083191 1199.653442,682.984619   C1199.235596,678.819763 1202.395630,675.413391 1203.502197,671.500610   C1204.150024,669.210449 1206.063599,667.104309 1204.500000,664.500000  "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "line-247",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1033.500000,363.000000   C1036.027100,362.220825 1037.463013,359.181580 1040.497437,359.522430   C1042.510010,359.748474 1048.680786,364.171448 1050.651611,366.694122   C1046.453003,371.567444 1044.352905,377.780945 1040.777954,383.183929   C1039.182373,385.595520 1036.626831,389.851105 1040.454224,393.547363   C1043.489746,396.478912 1041.462036,399.834412 1040.499390,402.999817   C1037.776367,411.953003 1036.123779,420.925140 1040.000000,430.000000  "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "line-248",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 944,350 c 8.95148,5.89398 17.50635,12.25131 25.04156,19.95935 5.06983,5.18616 11.95062,15.49085 16.31274,21.24925"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "line-249",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1070.500000,399.500000   C1063.926880,401.110931 1057.736084,398.744751 1051.529785,397.365936   C1048.515137,396.696228 1045.619751,395.781647 1042.500000,396.000000  "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "line-250",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M909.000000,782.000000   C906.740784,787.405212 901.985107,790.719299 897.892273,794.379517   C892.253784,799.421875 886.857727,804.681824 881.290466,810.206909   C874.306396,805.271057 866.530029,801.357910 860.500000,795.000000  "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "line-251",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1046.000000,691.499939   C1039.500000,694.333313 1033.156372,697.665588 1026.429199,699.773865   C1023.402527,700.722351 1019.732178,698.837891 1016.484253,697.539429   C1011.718323,695.634155 1007.861938,694.955200 1003.740967,700.300293   C999.210632,706.176392 992.664429,710.497437 987.001160,715.501343   C984.594910,717.627380 982.318176,719.825745 983.000000,723.500000  "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "line-253",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M867.000000,767.500000   C860.842163,768.719177 855.625305,765.338684 850.012756,763.948486   C846.487122,763.075073 843.304565,760.934021 839.500000,761.000000  "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "line-254",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1058.000000,336.500000   C1058.943848,340.277649 1056.868530,343.271759 1055.539795,346.516327   C1053.202271,352.224426 1049.291016,357.409302 1049.500000,364.000000  "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "line-255",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1117.500000,691.000061   C1108.666748,696.666748 1099.677368,702.113708 1091.130005,708.183167   C1089.396362,709.414307 1087.568481,709.392395 1085.904785,710.331360   C1084.212402,711.286682 1081.389648,707.994263 1082.599731,706.585632   C1085.697510,702.979431 1085.169556,698.606140 1086.039917,694.508484   C1086.520752,692.244690 1086.763306,690.009216 1088.354126,687.890503   C1089.946289,685.770142 1089.967285,682.737549 1089.000000,680.000000  "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "line-256",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M877.000000,706.500000   C881.216980,705.754700 884.321228,703.306519 887.590088,700.609192   C895.555115,694.036743 901.895020,685.664917 909.731140,679.283813   C925.275024,666.626160 939.254639,652.397888 953.256714,638.259094   C961.122864,630.316162 969.775635,623.714111 978.489075,616.985840   C980.788025,615.210632 983.054199,613.524658 985.989746,615.515137   C989.180664,617.678772 990.951843,620.410645 989.524109,624.508423   C987.694946,629.758301 988.618469,635.149536 989.000000,640.500000  "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "line-257",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M779.000000,290.500000   C776.204041,296.018768 771.240906,299.756195 767.487671,304.490204   C764.316101,308.490448 760.373901,312.110626 761.500000,318.000000  "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "line-258",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1101.000000,652.500000   C1094.444458,652.900269 1087.966431,654.121948 1081.475098,654.736450   C1076.304688,655.225891 1071.116577,655.481934 1066.000000,656.500000  "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "line-259",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1244.500000,443.500000   C1237.978027,443.789490 1233.034790,447.358856 1228.544556,451.547699   C1225.328369,454.548035 1222.174683,457.348022 1217.500000,457.500000  "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "line-260",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M837.000000,379.500000   C837.581116,383.451752 836.528625,386.975586 833.984375,389.986816   C829.728699,395.023743 828.129822,401.957886 822.500000,406.000000  "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "line-261",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 971.5,331.5 c 6.10419,2.71353 6.97052,9.35757 10.44196,14.04297 4.45672,6.01541 38.52034,36.50511 43.87914,41.78478"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "line-262",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m 924.5,364.5 c 3.28699,2.57001 6.98743,0.32779 10.52466,0.8244 13.77124,1.93341 23.5105,10.1991 32.35199,19.78934 2.35852,2.55826 11.97316,20.80907 14.07863,23.6892"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "line-264",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M683.000000,490.500000   C679.720825,486.930511 675.057068,484.780334 673.318787,479.560364   C672.474792,477.026062 668.923706,475.105438 666.509705,475.214417   C658.499939,475.576050 651.956543,471.757324 644.997009,469.007507   C643.183472,468.290924 641.333313,467.666656 639.500000,467.000000  "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "line-265",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1071.500000,502.500000   C1069.368042,511.944946 1066.689941,521.187622 1061.500000,529.500000  "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "line-266",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1051.000000,731.000000   C1056.956665,736.964478 1063.880249,734.153259 1070.476440,732.878418   C1072.804565,732.428467 1075.016235,731.297974 1077.500000,731.500000  "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "line-267",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1002.000000,417.500000   C1001.833374,417.833344 1001.448181,418.239594 1001.531494,418.489471   C1004.403748,427.097687 1006.490356,436.000336 1011.000000,444.000000  "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "line-268",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1122.000000,708.000000   C1118.256958,708.932800 1114.467407,709.758850 1111.501709,712.501892   C1111.155884,712.821777 1110.810547,713.477356 1110.503296,713.454956   C1100.811157,712.746765 1094.885620,722.382690 1085.500854,722.549011   C1084.206543,722.571960 1083.358032,723.850830 1083.044067,725.011902   C1082.326660,727.665894 1079.543701,728.657776 1078.362793,730.996643   C1079.590942,737.624268 1076.618652,744.654785 1080.500000,751.000000  "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "line-269",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1085.000000,576.000000   C1092.286377,583.055420 1102.123291,582.461914 1111.038452,584.314758   C1115.189209,585.177368 1119.511841,587.137329 1124.001953,585.505371   C1125.063965,585.119446 1126.732910,585.275940 1126.932617,583.989563   C1127.641479,579.424866 1132.094971,577.583618 1133.929688,573.964355   C1135.857544,570.161011 1138.866455,567.977295 1142.419922,565.865173   C1145.391479,564.098877 1145.964966,560.073181 1148.278687,557.314392   C1151.255859,553.764465 1154.328125,552.636536 1158.500000,553.000000  "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "line-270",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M908.000000,573.500000   C909.683472,577.022278 906.930176,579.593384 905.928284,582.475037   C904.732666,585.914246 903.134094,589.236084 901.456421,592.477417   C900.183472,594.936768 900.524963,597.458862 900.500000,600.000000  "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "line-271",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M719.000000,647.500000   C708.095459,650.606201 699.088867,656.339661 693.557190,666.531067   C691.751099,669.858337 691.808777,674.060913 689.000000,677.000000  "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "line-272",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1041.500000,432.500000   C1042.797852,435.245850 1045.431519,436.881500 1046.695923,439.918396   C1048.848511,445.088440 1048.539429,449.291046 1045.025757,453.521423   C1043.108765,455.829407 1042.951660,458.368713 1043.328735,461.520477   C1044.280518,469.477966 1044.471558,477.537323 1045.072754,485.532135   C1045.318237,488.796417 1044.428955,492.163361 1045.895874,495.545166   C1046.406616,496.722870 1046.533081,498.615631 1045.000000,499.750000  "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "line-273",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M815.000000,367.500000   C812.029236,366.921082 809.510315,367.971527 807.527649,370.026703   C803.270630,374.439514 799.072205,378.917816 795.049622,383.543182   C793.577209,385.236328 792.458435,387.156403 790.000000,387.500000  "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "line-274",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M924.500000,619.000000   C915.385376,617.511719 907.738647,621.679382 900.666748,626.257629   C897.932678,628.027588 895.856506,629.759583 892.496155,629.566772   C891.186279,629.491699 889.833313,630.166687 888.500000,630.500000  "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "line-275",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M941.000000,456.500000   C941.016541,465.423401 939.934082,474.537048 945.500000,482.500000  "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "line-276",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M935.500000,504.000000   C932.040527,500.126648 926.507446,499.390717 922.837646,495.659698   C922.157471,494.968170 919.409790,495.117645 917.424988,496.382233   C912.779907,499.341614 906.882935,499.860474 902.514526,503.517365   C901.655823,504.236206 900.872864,503.789764 900.000183,503.793091   C889.427368,503.833344 880.497925,509.836731 870.506958,512.031616   C870.119080,512.116821 869.833313,512.666626 869.500000,513.000000  "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "line-277",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M835.500000,687.000000   C833.753967,695.580566 831.582275,704.112061 832.500000,713.000000  "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "line-278",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1226.500000,360.000000   C1222.597046,364.675720 1221.387451,370.620209 1219.061646,376.026520   C1217.672607,379.255096 1215.475952,382.249908 1215.500000,386.000000  "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "line-279",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M972.500000,760.500000   C966.382263,760.128113 961.692505,764.491760 955.997681,765.486755   C948.161804,766.855774 941.081970,771.091980 933.000000,771.500000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-280",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M808.000000,476.500000   C801.069031,484.551544 793.511963,492.004211 786.000000,499.500000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "line-281",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M875.500000,357.500000   C869.250916,358.929016 864.124878,362.762054 858.546021,365.590729   C855.542786,367.113464 852.749939,367.999786 849.500000,367.000000  "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "line-282",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1109.500000,600.000000   C1102.500000,607.166687 1095.517090,614.350098 1088.493530,621.493591   C1084.362427,625.695251 1080.207886,629.875916 1075.977295,633.976562   C1074.521362,635.387634 1073.459473,637.465881 1071.000000,637.500000  "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "line-284",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1042.000000,458.500000   C1036.497437,457.300690 1034.100952,462.163239 1030.566528,464.596588   C1027.094849,466.986816 1024.123779,470.120819 1021.018921,473.020233   C1019.565430,474.377686 1017.956787,475.058655 1016.000000,475.000000  "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "line-285",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M995.500000,316.000000   C999.000000,321.333344 1002.577881,326.617767 1005.969604,332.019104   C1007.879272,335.060303 1008.876770,338.385162 1007.500000,342.000000  "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "line-286",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M836.000000,672.500000   C835.666626,672.166687 835.361328,671.577576 834.995911,671.537537   C826.661255,670.623779 818.457092,671.112915 810.500000,674.000000  "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "line-287",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M807.500000,273.500000   C804.159119,271.954712 801.295349,272.219482 798.453491,274.951630   C793.355225,279.853302 786.745178,283.147125 783.000000,289.500000  "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "line-288",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M858.500000,431.500000   C858.284546,432.800812 857.363159,433.618042 856.506409,434.506195   C842.731934,448.786469 828.251221,462.306885 813.000000,475.000000  "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "line-289",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1239.500000,504.000000   C1233.256836,498.658997 1226.426147,501.321960 1220.058228,503.197510   C1216.403442,504.273895 1211.366211,504.747406 1210.129395,509.533447   C1209.392700,512.384521 1210.345947,515.657043 1208.971191,518.486023   C1207.070801,522.396545 1207.790527,527.384949 1204.000000,530.500000  "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "line-290",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1055.500000,520.000000   C1058.171143,524.201721 1060.314453,528.493896 1061.825439,533.399780   C1063.093384,537.516479 1065.759888,541.538269 1067.964233,545.519775   C1070.128418,549.428894 1071.856323,553.582886 1074.087402,557.449585   C1074.756714,558.609497 1074.014771,559.166687 1074.000000,560.000000  "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "line-291",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M839.500000,453.000000   C847.977966,459.075958 857.486267,463.357300 866.207336,468.471710   C865.213257,474.093719 861.837341,479.441650 864.500000,485.500000  "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "line-292",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1162.000000,513.000000   C1163.533325,516.207397 1161.314331,519.006653 1160.915649,521.988708   C1160.192871,527.393860 1159.294067,532.803894 1157.500000,538.000000  "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "line-293",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1166.000000,689.000061   C1159.666748,692.333374 1153.396118,695.796326 1146.958374,698.914062   C1145.222900,699.754578 1143.302368,701.480530 1141.000000,700.000000  "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "line-294",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M826.500000,715.500000   C826.018799,717.018799 824.809631,717.960388 823.484741,718.459473   C816.656128,721.031494 809.808838,723.580933 802.500000,724.500000  "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "line-295",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M990.500000,202.000000   C984.990906,200.625061 979.785278,202.681030 974.515320,203.588898   C971.480774,204.111664 967.954956,203.204605 965.500000,206.000000  "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "line-296",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M995.000000,459.500000   C995.083313,459.666687 995.211304,459.825195 995.243408,460.001190   C996.103149,464.707092 994.536743,469.977661 992.161377,472.705078   C987.194885,478.407349 981.460571,483.861786 974.494446,487.489288   C973.702332,487.901764 972.682190,487.983948 972.023682,488.528625   C966.137939,493.396851 954.647522,499.415405 947.530518,501.599518   C946.457458,501.928864 945.486938,501.754944 944.500000,502.000000  "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "line-297",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M849.000000,254.500000   C852.265747,262.510986 857.614197,268.898895 864.546143,273.936523   C865.966675,274.968933 867.044434,276.122223 868.000000,277.500000  "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "line-298",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1276.000000,479.500000   C1279.520752,481.469971 1280.049438,485.285736 1280.861572,488.534607   C1282.135010,493.628662 1283.681274,498.595612 1285.500000,503.500000  "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "line-299",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9,
    d: " M787.000000,502.000000   C793.874573,505.451630 800.283752,509.738556 808.491211,510.167908   C814.076599,510.460144 819.261353,514.052673 824.997498,513.903320   C831.390320,513.736694 837.588257,515.512329 844.006165,515.094604   C848.808289,514.782043 853.666687,515.333374 858.500000,515.500000  "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "line-300",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1060.000000,700.000000   C1054.383423,705.678406 1046.780029,708.904968 1041.486328,714.988098   C1041.260132,715.247986 1040.824951,715.493408 1040.501221,715.476746   C1029.407349,714.904114 1024.839722,724.671448 1017.534241,730.046509   C1012.193115,733.976135 1007.477905,738.829834 1001.893494,742.330078   C997.997314,744.772156 992.761353,745.032349 989.051636,748.063171   C985.038574,751.341797 979.764465,752.408936 976.000000,756.000000  "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "line-301",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1015.500000,269.000000   C1010.557556,267.904236 1006.715698,271.091125 1002.555237,272.647583   C998.768005,274.064392 994.840149,275.212372 991.353943,277.803528   C988.578064,279.866669 984.500000,278.136047 981.000000,278.000000  "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "line-302",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M700.500000,307.000000   C705.863464,306.803864 708.863892,302.246429 712.841553,299.747772   C720.159241,295.151001 727.886475,291.478180 736.067688,289.837585   C741.600342,288.728088 747.057129,286.671753 752.520630,286.330627   C757.187012,286.039215 762.148621,286.877930 766.999268,287.024811   C772.097290,287.179169 776.665833,290.331909 782.012695,289.591736   C784.137085,289.297638 784.972656,291.868469 786.500000,293.000000  "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "line-303",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M701.000000,447.500000   C697.777283,455.358185 695.361450,463.348114 697.000000,472.000000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-304",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M952.000000,373.500000   C948.008484,381.234039 947.461792,390.062775 944.172546,398.070862   C942.814819,401.376373 946.934753,403.880859 948.000000,407.000000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "line-305",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M923.500000,642.500000   C918.830200,645.163574 915.020813,648.388794 912.341431,653.415466   C908.830200,660.002930 903.006348,664.987793 897.974792,670.476868   C890.505981,678.624878 881.101318,684.560974 872.954712,691.950073   C871.697083,693.090759 869.886963,693.734436 868.000000,693.500000  "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "line-307",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M 886.41773,402.6466 C 879.74396,409.24124 867.46753,421.96893 862.5,430"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "line-308",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1044.000000,501.000000   C1041.965698,502.689301 1041.388672,504.800476 1040.795898,507.454407   C1039.229126,514.469299 1040.145020,522.090088 1036.000000,528.500000  "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "line-309",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M690.750000,398.000000   C687.642273,406.610107 690.070801,415.332672 690.320312,423.997986   C690.403320,426.883514 692.816162,428.939789 694.588623,430.920715   C697.381409,434.041809 700.304810,436.868347 700.005310,441.500336   C699.673889,446.627960 703.827026,449.130829 706.497986,452.501617   C710.232117,457.214142 710.197449,457.397095 706.509338,462.007477   C703.701111,465.518097 701.167542,469.183319 697.587280,472.106873   C695.022766,474.200958 694.880127,477.735229 695.000000,481.000000  "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "line-310",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M929.500000,823.000000   C923.447998,827.406799 916.424805,827.095459 909.502869,826.899536   C908.088196,826.859436 906.535706,825.736145 906.000000,824.000000  "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "line-311",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M641.500000,555.500000   C644.924744,561.011658 644.959595,567.470520 646.415344,573.520386   C646.898804,575.529541 647.076233,577.605957 648.000000,579.500000  "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "line-312",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M842.000000,229.500000   C839.238281,235.358109 833.796204,238.990005 829.844299,243.874039   C827.284119,247.038132 826.446472,249.836792 827.500000,253.500000  "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "line-313",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1116.000000,331.500000   C1117.866211,334.680054 1116.897095,338.164581 1116.942871,341.500793   C1117.010742,346.444153 1116.771118,351.382141 1119.000000,356.000000  "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "line-314",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1103.500000,417.000000   C1098.933105,416.299591 1096.026001,419.733459 1092.526489,421.550903   C1079.313354,428.412811 1067.109863,436.888489 1054.985229,445.479218   C1053.336182,446.647614 1051.326782,445.761169 1049.500000,446.000000  "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "line-315",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M909.000000,161.000015   C913.666687,155.333344 918.503174,149.792709 922.872864,143.905655   C923.884094,142.543320 925.956421,140.054962 923.460327,138.049408   C921.527954,136.496765 919.444824,138.194717 918.071106,139.107101   C911.648132,143.373016 905.278931,147.771561 900.000000,153.500000  "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "line-316",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M879.000000,327.000000   C878.884399,333.961365 875.496704,337.993469 868.507324,339.048615   C866.531311,339.346893 864.860352,340.099426 863.912292,342.464844   C861.144775,349.369720 855.556702,354.560577 852.039246,361.021362   C848.379578,367.743347 842.804260,372.959412 837.279053,377.744904   C832.311035,382.047760 826.199890,385.286255 821.052917,389.563660   C814.045288,395.387146 805.326050,398.999542 799.878723,406.916534   C796.833313,411.342590 798.214172,415.575989 798.500000,420.000000  "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "line-317",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M792.500000,406.500000   C788.338257,407.684174 784.657898,410.600800 780.001038,409.991943   C779.160339,409.882019 778.805664,410.308075 778.479736,410.455109   C769.194946,414.643738 760.921082,415.487976 751.006531,415.748566   C745.303833,415.898438 739.646118,415.199921 734.010376,415.634552   C731.832336,415.802521 730.596863,414.528473 729.042480,413.895691   C723.798340,411.760895 718.292297,410.162262 713.500000,407.000000  "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "line-320",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M899.000000,276.500000   C899.000000,276.833344 899.135254,277.259705 898.979614,277.485962   C896.898926,280.509735 896.215698,283.938995 895.158325,287.395477   C893.177124,293.871918 887.975647,298.821503 882.926758,303.419586   C882.114990,304.158936 880.333313,303.833344 879.000000,304.000031  "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "line-321",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M685.000000,363.500000   C686.666687,368.166656 688.311401,372.841309 690.004272,377.498444   C694.411560,389.623169 702.064026,399.138397 712.985413,405.990753   C713.401306,407.244873 712.593933,408.304871 711.945679,408.944977   C708.784241,412.066681 708.746582,414.405914 711.800842,418.161957   C715.055481,422.164429 714.663147,429.603424 709.978394,432.464630   C708.279297,433.502319 706.333313,433.921173 704.500000,432.500000  "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "line-322",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1045.500000,219.000000   C1046.888794,222.611160 1049.971558,225.179214 1052.701904,227.231369   C1055.258545,229.153061 1059.496826,228.850891 1063.001343,229.492661   C1064.775024,229.817459 1066.952148,229.611328 1066.500000,232.500000  "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "line-323",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1154.000000,649.500000   C1151.351807,649.909363 1150.251465,652.316040 1149.121948,654.078125   C1146.722168,657.821899 1145.286255,662.183289 1142.888550,665.928650   C1141.530518,668.050049 1142.115723,669.963745 1142.000000,672.000000  "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "line-324",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M897.000000,286.000000   C901.441895,288.891815 906.616821,288.334930 911.509583,288.919800   C914.631775,289.292969 917.873718,288.723267 920.750000,290.500000  "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "line-325",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1150.000000,613.000000   C1146.131592,617.373596 1141.822754,621.240479 1140.307495,627.453064   C1139.349243,631.382019 1134.528931,632.792664 1131.896240,635.912415   C1127.880249,640.670959 1122.745972,644.317505 1118.552856,649.108643   C1115.533936,652.558167 1109.824951,655.737061 1104.000000,656.000000  "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "line-326",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M924.500000,757.500000   C923.000000,756.394653 921.426880,756.913818 920.012573,757.528931   C913.650391,760.295898 907.333313,763.166626 901.000000,765.999939  "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "line-327",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M788.500000,319.000000   C787.449951,324.966187 787.774414,330.795166 789.963440,336.513977   C790.695068,338.425323 791.000000,340.500000 791.500000,342.500000  "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "line-328",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1244.500000,539.500000   C1246.421753,543.847046 1244.051025,547.851379 1243.496826,551.999573   C1243.008789,555.652832 1241.182861,559.183289 1242.500000,563.000000  "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "line-330",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M948.000000,748.000000   C945.184692,747.144165 942.674988,747.163391 939.945557,748.915161   C935.310120,751.890198 929.227295,753.366333 925.811951,757.272766   C922.416016,761.156799 918.436707,763.646545 914.495300,766.493530   C914.197144,766.708862 913.827576,766.822815 913.500977,767.001831   C911.913696,767.871948 911.200562,769.183594 911.500000,771.000000  "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "line-331",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1018.500000,304.000000   C1011.873962,306.581207 1005.750793,310.166443 999.488586,313.478424   C997.908203,314.314270 996.485718,315.631042 994.500000,315.500000  "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "line-332",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1056.500000,589.000000   C1053.655762,592.709778 1049.926147,595.956299 1048.575562,600.522339   C1045.282104,611.655823 1035.158447,618.410706 1030.808350,628.920654   C1029.559326,631.938416 1026.028687,634.029541 1023.489990,636.489685   C1021.755920,638.170227 1020.842773,640.248291 1021.561035,642.480347   C1022.993408,646.930969 1021.857605,651.016174 1019.389465,654.419861   C1016.564880,658.315186 1019.604309,661.133423 1020.747925,663.897461   C1021.657837,666.096802 1024.797852,665.559753 1027.525635,665.188599   C1032.484131,664.513916 1037.259766,663.008057 1042.497803,662.986267   C1046.032959,662.971497 1050.964600,660.759216 1053.689453,656.111084   C1056.479980,651.351013 1060.639404,647.309937 1066.000000,645.000000  "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "line-333",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1174.500000,705.000000   C1169.449463,708.778198 1163.305664,709.715515 1157.486572,711.455139   C1155.355103,712.092346 1153.392944,710.928284 1151.500000,710.000000  "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "line-334",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M883.500000,809.000000   C886.824951,812.753662 891.750916,813.215576 896.032288,814.918823   C899.442932,816.275757 903.293823,816.467041 906.494995,818.507874   C907.858276,819.376953 909.250793,819.189453 910.486023,818.475769   C917.340881,814.514832 923.198059,819.543518 929.497192,820.518005   C930.538147,820.679016 931.407410,821.162048 930.750000,822.500000  "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "line-335",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M869.500000,405.000000   C867.410522,403.830078 865.316833,404.004852 862.984070,404.407959   C859.382629,405.030273 855.890747,406.191010 851.961487,405.144623   C847.931152,404.071320 844.419739,407.263031 840.538452,408.165436   C836.085388,409.200867 831.606628,410.833252 828.000000,414.000000  "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "line-336",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1188.500000,548.000000   C1181.807617,550.448669 1175.910767,554.486023 1169.506104,557.512878   C1164.853638,559.711548 1159.562744,556.539917 1159.478760,551.500366   C1159.428711,548.498413 1159.091553,545.501648 1159.026367,542.499451   C1158.982666,540.486816 1158.178711,538.971375 1156.490967,538.015869   C1151.158203,534.996643 1146.978638,530.475159 1142.000000,527.000000  "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "line-337",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M981.000000,320.000000   C985.733704,322.013977 987.528564,326.716766 989.848328,330.590820   C993.465698,336.631989 999.136230,339.594818 1005.070374,341.811584   C1009.711060,343.545166 1013.253052,345.521179 1014.500000,350.500000   C1014.666931,351.166595 1014.675354,352.315674 1015.023071,352.429565   C1023.980408,355.363342 1020.096313,364.423798 1023.426758,370.043396   C1025.277710,373.166351 1024.507568,377.692688 1028.500000,379.750000  "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "line-338",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1120.500000,524.000000   C1114.666626,525.000000 1111.294556,529.705872 1107.022827,533.029297   C1104.126343,535.282715 1101.673584,538.246460 1097.500000,538.000000  "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "line-339",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M997.500000,230.500000   C991.975830,228.879028 987.513062,232.563171 982.504395,233.522781   C979.839172,234.033386 977.426941,235.888199 974.500000,235.000000  "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "line-340",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M801.000000,348.000000   C797.789368,353.758240 795.495544,359.922699 792.850830,365.934357   C791.936157,368.013580 792.688049,369.333344 793.000000,371.000000  "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "line-341",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1071.000000,570.000000   C1067.789429,574.789368 1062.800903,577.796814 1058.931030,581.935547   C1058.363770,582.542236 1057.193359,583.742065 1056.020386,582.968994   C1052.391724,580.577271 1050.161987,583.301575 1047.474243,584.958130   C1042.901123,587.776672 1038.164429,590.329468 1033.501465,593.002502   C1032.230957,593.730774 1030.933838,594.136902 1029.500000,593.500000  "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "line-342",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M874.000000,243.500000   C875.622314,246.324265 878.598938,245.659943 881.009277,245.911316   C886.130249,246.445389 891.162537,247.187286 896.000000,249.000000  "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "line-343",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.4954,
    d: "m 886.03911,401.32387 c 7.2123,9.48663 14.42471,18.97325 21.63702,28.45988"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "line-344",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M817.000000,359.500000   C816.333313,364.333344 816.891357,369.839874 814.696289,373.833038   C811.821167,379.063385 811.261414,384.643097 809.402954,389.966095   C808.576416,392.333374 808.893066,394.333344 809.500000,396.500000  "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "line-345",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M976.500000,730.000000   C976.722473,732.710388 976.085510,734.839600 974.091187,737.081116   C966.389526,745.737549 957.469666,753.133423 949.407776,761.410156   C947.721680,763.141174 946.443787,764.590515 946.500000,767.000000  "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "line-346",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M997.000000,655.500000   C995.752686,660.000000 997.044067,664.499878 997.023621,669.000122   C997.020691,669.666016 997.112000,670.567627 997.532959,670.965149   C1004.626343,677.663879 1004.678467,687.922546 1010.000000,695.500000  "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "line-347",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M734.500000,720.000000   C736.971619,718.021301 739.913208,716.694885 742.618835,715.217651   C745.417969,713.689453 748.721741,713.548706 752.599182,714.651123   C759.226074,716.535034 766.385498,718.071228 773.500000,716.000000  "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "line-348",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M899.500000,629.000000   C903.991455,632.145142 909.116821,630.870239 914.000793,630.955994   C922.842651,631.111206 923.106140,631.388062 923.562805,640.496826   C923.731445,643.861145 927.342712,645.723633 927.738647,649.474792   C928.050964,652.433472 930.500000,655.166626 932.000000,658.000000  "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "line-349",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M984.000000,391.000000   C990.920593,395.563080 993.643555,403.156067 996.751160,410.111206   C998.621338,414.296814 1000.444946,416.042480 1004.925537,417.271454   C1011.383545,419.042725 1017.331238,422.671204 1023.502441,425.494598   C1024.317749,425.867554 1025.166626,426.166687 1026.000000,426.500000  "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "line-350",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M665.000000,572.500000   C667.156982,577.942932 668.446655,583.679810 670.871338,589.057983   C671.759460,591.027893 672.648804,592.858215 674.000000,594.500000  "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "line-351",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M674.000000,657.000000   C677.810852,659.834534 679.096130,664.488586 681.882019,668.091248   C684.132202,671.001160 685.990173,674.215454 688.440918,677.051086   C691.351929,680.419189 691.680786,684.681213 691.517273,689.000671   C691.191345,697.609558 697.031006,703.418640 702.758789,707.649658   C708.417847,711.829956 714.941406,715.403931 721.485535,718.530273   C722.423340,718.978333 723.166687,719.833313 724.000000,720.500000  "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "line-352",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M1083.500000,722.500000   C1081.797363,721.039978 1080.641235,718.972656 1078.046021,718.103699   C1074.807983,718.053955 1071.605469,720.018677 1067.438599,719.451172   C1064.247437,719.016602 1059.754150,721.946045 1057.148315,724.643250   C1050.860840,731.151306 1041.664062,732.318359 1034.830322,737.788025   C1033.136963,739.143250 1030.578857,740.292114 1028.569336,741.606018   C1022.397217,745.641479 1015.508423,747.545288 1008.486816,748.933167   C998.141663,750.977844 989.213928,755.934448 980.481934,761.471558   C979.110657,762.341125 977.500000,762.833252 976.000000,763.499939  "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "line-353",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M964.500000,667.000000   C960.850220,665.390442 957.715210,667.620361 954.522644,668.575745   C944.354675,671.618225 934.034729,673.831909 923.492432,674.926880   C921.712891,675.111694 919.833313,674.333313 918.000000,674.000000  "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "line-354",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M851.000000,494.000000   C850.962341,496.244080 849.957153,497.677582 848.062012,499.083588   C843.699707,502.319885 839.576721,505.901581 835.563416,509.569397   C834.563049,510.483673 833.326538,511.746613 833.500000,513.500000  "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "line-355",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1201.000000,558.000000   C1203.527588,561.113892 1202.404175,564.528809 1202.092896,568.008301   C1201.767212,571.649414 1200.687256,575.144714 1201.305664,579.030945   C1201.948853,583.073425 1198.156494,585.437622 1195.500000,588.000000  "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "line-356",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M693.500000,557.000000   C695.754089,561.923950 694.979004,567.413330 696.372742,572.534607   C696.948975,574.651917 697.530212,576.826355 698.000000,579.000000  "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "line-357",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1123.000000,608.000000   C1118.658081,614.994690 1117.991577,624.180603 1110.066528,629.107117   C1108.338867,630.181091 1109.802002,632.998169 1108.631714,635.074280   C1106.041870,639.669006 1104.182739,644.674011 1101.989624,649.495300   C1101.369141,650.859253 1101.016968,652.493713 1102.059204,653.434326   C1104.502563,655.639465 1103.638794,657.947632 1101.921997,659.408325   C1098.165527,662.604431 1095.687134,666.780457 1094.195312,671.067993   C1091.849365,677.810242 1085.703613,679.743530 1080.948730,683.433960   C1079.117188,684.855469 1077.840698,686.439209 1077.000000,688.500000  "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "line-359",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M952.000000,460.000000   C953.758423,454.980133 954.147766,449.687683 954.914551,444.487396   C955.198975,442.558472 955.097534,440.841583 957.500305,440.502075   C968.019653,439.015747 978.652039,437.129944 988.458923,443.067810   C992.928589,445.774078 997.417175,448.749481 999.500000,454.000000  "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "line-360",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1026.000000,403.500000   C1031.135254,407.081055 1028.331787,412.437469 1028.864380,417.015778   C1028.930176,417.580994 1028.854492,418.767090 1028.469604,419.483673   C1026.124146,423.849823 1026.857300,428.166656 1028.500000,432.500000  "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "line-361",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1055.000000,446.500000   C1061.322754,453.676056 1068.483154,460.111816 1074.000000,468.000000  "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "line-362",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1017.000000,614.500000   C1020.367249,617.675659 1018.856201,621.794067 1018.908508,625.501282   C1018.963196,629.382568 1019.360657,632.968384 1022.000000,636.000000  "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "line-363",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1113.500000,682.500000   C1105.885620,686.236389 1100.728027,693.237671 1093.517578,697.529602   C1091.145630,698.941589 1089.221558,701.304016 1086.000000,700.500000  "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "line-364",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M835.000000,756.500000   C840.220215,759.503113 839.127136,765.721802 841.863220,770.085754   C845.192993,775.396790 846.904846,781.752625 852.426453,785.816711   C857.247864,783.159546 862.036987,781.346252 867.479980,780.800354   C871.296326,780.417603 874.292725,777.352539 876.500000,774.000000  "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "line-365",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1025.500000,558.999939   C1020.999939,564.333252 1016.408875,569.593750 1012.051758,575.041382   C1010.625793,576.824158 1009.327087,578.492188 1007.000000,579.000000  "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "line-366",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M873.000000,318.000000   C864.959290,317.866333 859.940186,323.531677 854.638428,328.158630   C852.350891,330.155121 850.227051,332.139465 847.509338,333.518372   C843.247681,335.680511 838.677429,337.124084 834.355530,339.199127   C830.904419,340.856110 826.166687,339.833344 822.000000,340.000031  "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "line-367",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M907.500000,428.500000   C912.332214,435.963104 920.006531,440.340424 926.495850,446.004761   C927.027344,446.468689 927.500000,447.000031 928.000000,447.500031  "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "line-368",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M795.500000,299.000000   C795.166687,299.500000 794.944885,300.168274 794.482971,300.474304   C789.037964,304.082184 789.174805,310.084930 788.045837,315.509552   C787.761597,316.875610 787.774841,318.023529 789.970337,318.610901   C798.510986,320.895752 803.582275,327.548828 807.849976,334.590942   C809.618835,337.509705 808.339417,341.499725 808.500000,345.000000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-369",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1069.000000,601.000000   C1074.477783,605.791504 1078.164307,611.963806 1081.943359,618.035217   C1082.848145,619.488525 1083.779907,620.831726 1085.000000,622.000000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "line-370",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1117.000000,178.500000   C1116.562866,183.281448 1113.186646,186.630554 1110.918701,190.451767   C1105.928589,198.859268 1098.984863,205.773178 1092.425781,212.931976   C1090.424927,215.115799 1089.817871,217.304001 1090.000000,220.000000  "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "line-371",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1151.000000,674.000000   C1145.565430,680.400635 1140.467773,686.994385 1132.045654,690.122925   C1125.867798,692.417847 1121.753662,701.732544 1123.005005,708.499084   C1124.211792,715.024414 1121.445068,720.529785 1117.354492,724.862610   C1113.001343,729.473450 1107.491455,732.989502 1102.505249,737.006531   C1100.990845,738.226440 1099.226685,737.966736 1097.500000,738.000000  "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "line-372",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M720.000000,272.500000   C722.068848,274.235229 721.954651,276.594818 722.036133,278.998779   C722.203186,283.930298 722.337341,288.895874 724.500000,293.500000  "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "line-373",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M971.500000,520.500000   C965.948425,520.564880 962.074707,516.717896 957.494629,514.511169   C955.256775,513.432983 953.345581,511.398956 950.500000,512.000000  "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "line-374",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1108.000000,292.500031   C1103.333374,294.833344 1098.408081,296.779510 1094.103149,299.654572   C1091.761597,301.218445 1089.640747,302.027588 1087.000000,302.000000  "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "line-375",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1041.000000,572.500000   C1037.027344,579.515625 1031.415405,585.532227 1028.825073,593.442688   C1028.154541,595.490112 1025.573608,597.334106 1023.433228,598.360840   C1021.240051,599.413025 1019.685425,600.963318 1018.000000,602.500000  "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "line-376",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1191.000000,524.500000   C1192.886719,529.404114 1190.505859,534.163391 1190.312622,538.992493   C1190.226318,541.150269 1190.429443,543.033630 1191.000000,545.000000  "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "line-377",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M967.000000,334.000000   C962.795532,334.185333 959.254089,335.296753 955.873535,338.360413   C951.282532,342.520935 945.828430,345.773163 940.726440,349.325226   C934.837463,353.425293 928.070251,357.042236 924.019043,363.511902   C923.869080,363.751373 924.102844,364.415833 923.985291,364.464355   C916.489746,367.557770 910.813416,373.620667 903.500000,377.000000  "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "line-378",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1188.500000,567.500000   C1180.338867,570.996948 1172.312500,574.760620 1164.448853,578.902832   C1162.285645,580.042297 1159.518433,580.201111 1156.993896,580.432983   C1155.151855,580.602112 1153.479126,580.661316 1152.577637,582.827637   C1154.003662,588.754089 1151.742798,595.305420 1154.000000,601.500000  "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "line-379",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M674.000000,597.500000   C679.233704,603.850159 681.796021,611.959534 687.500000,618.000000  "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "line-380",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M801.000000,731.000000   C804.798645,737.076111 810.443665,741.248657 816.015076,745.480164   C817.548462,746.644836 818.965759,747.867554 820.000000,749.500000  "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "line-381",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1182.000000,630.500000   C1176.184937,630.533813 1170.987427,633.115234 1165.485962,634.441956   C1164.247681,634.740540 1162.833374,635.705872 1161.500000,634.500000  "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "line-382",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1105.500000,200.000000   C1108.656372,203.595200 1113.244873,201.552261 1117.057251,202.829041   C1119.920776,203.788010 1123.134766,203.673737 1125.500000,206.000000  "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "line-383",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1187.000000,254.499985   C1184.833252,261.166656 1182.666626,267.833313 1180.500000,274.500000  "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "line-384",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M964.250000,206.500000   C964.530457,209.264847 966.285706,209.215332 968.504333,209.063339   C971.987976,208.824692 975.501343,209.058395 978.999512,208.978363   C981.138367,208.929443 983.037842,209.312531 984.500000,211.000000  "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "line-385",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M774.000000,414.500000   C775.286072,417.216064 773.168213,419.198792 772.654907,421.534058   C771.725830,425.760773 768.025940,429.765808 771.000000,434.500000  "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "line-386",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M849.500000,656.500000   C842.753174,654.392822 836.103210,653.940125 828.939636,655.139221   C825.568359,655.703491 820.991760,653.811035 817.973328,650.524475   C812.232117,644.273193 806.333313,638.166687 800.500000,632.000000  "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "line-387",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1006.500000,489.000000   C1008.816528,492.691010 1008.793152,496.904053 1008.932495,501.002289   C1009.030579,503.886536 1009.307373,506.589813 1011.000000,509.000000  "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "line-388",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1273.000000,466.000000   C1268.655273,467.814331 1266.947754,472.060669 1264.565186,475.544617   C1257.776367,485.471649 1250.031982,494.594177 1242.000000,503.500000  "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "line-389",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1018.000000,424.000000   C1015.377991,430.443085 1015.432373,437.220703 1015.500000,444.000000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-390",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M952.500000,462.000000   C949.245850,468.137512 949.370178,475.401154 946.000000,481.500000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "line-391",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1014.000000,482.000000   C1010.499451,482.468903 1007.491272,482.488464 1006.132874,487.398438   C1005.246216,490.603638 1000.963318,492.990845 997.968689,495.462067   C993.754028,498.940277 990.062134,502.895477 986.500000,507.000000  "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "line-392",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1200.500000,491.000000   C1201.720459,496.971771 1198.519165,501.960632 1196.295898,506.908295   C1194.662720,510.542633 1194.351929,513.333313 1196.500000,516.500000  "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "line-393",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M733.000000,433.500000   C735.941650,437.060760 734.476929,441.533539 735.384949,445.526154   C735.946838,447.996796 736.270020,450.545990 737.000000,453.000000  "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "line-394",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1040.000000,435.000000   C1036.331299,441.705231 1038.354858,448.118561 1041.000000,454.500000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-395",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11,
    d: " M1033.000000,373.500000   C1029.583618,377.208496 1027.997681,381.833130 1026.512695,386.504028   C1026.416382,386.806763 1026.361938,387.266541 1026.520264,387.485352   C1030.353149,392.783600 1026.493530,397.733032 1025.225220,402.425720   C1024.077271,406.673248 1021.007324,410.445007 1019.951050,414.988617   C1019.393738,417.386108 1018.333374,419.666687 1017.500061,422.000000  ",
    style: {
      strokeWidth: 4,
      strokeDasharray: "none"
    }
  }), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "line-396",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1149.500000,567.500000   C1145.049438,573.702759 1141.053589,580.217163 1136.494629,586.366638   C1132.074463,592.328735 1127.170044,598.863586 1125.000000,606.500000  "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "line-397",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M744.000000,633.000000   C749.706177,636.518494 753.461243,642.262451 758.938232,646.088440   C760.412537,647.118408 761.676208,648.249451 763.500000,648.500000  "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "line-398",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1092.500000,639.000061   C1087.833374,642.333435 1083.198853,645.713135 1078.484375,648.977600   C1076.557983,650.311646 1074.775757,651.681519 1074.000000,654.000000  "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "line-400",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M731.000000,432.500000   C725.023865,441.075439 717.397827,448.275940 711.000000,456.500000  "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "line-401",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M998.500000,455.000000   C993.590698,460.938416 985.686768,462.229004 979.921509,466.903168   C978.650940,467.933289 976.766663,468.244415 976.000000,470.000000  "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "line-402",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1065.500000,500.000000   C1059.631470,496.458649 1053.672607,493.346802 1046.500000,496.000000  "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "line-403",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M861.500000,495.000000   C859.631775,504.071960 859.560974,513.339966 858.500000,522.500000  "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "line-404",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M986.500000,476.000000   C983.292786,472.799988 978.167297,473.304443 974.954651,470.044708   C974.626160,469.711395 973.414185,469.712219 973.037537,470.042755   C966.387634,475.878021 957.091614,477.094421 950.500000,483.000000  "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "line-405",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1013.500000,346.000000   C1018.677368,341.180603 1022.487793,346.469574 1026.416626,348.190460   C1030.173218,349.835999 1034.011963,351.898804 1037.000000,355.000000  "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "line-406",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1042.000000,402.500000   C1044.892456,405.839630 1044.553467,410.077026 1044.897461,414.008972   C1045.160400,417.013550 1045.169922,419.940399 1047.000000,422.500000  "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "line-407",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1136.500000,713.000000   C1132.227539,718.821411 1126.989014,723.149597 1119.500000,724.000000  "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "line-408",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M711.000000,697.000000   C713.877502,703.532104 720.972656,704.039917 725.964600,707.550354   C731.154968,711.200195 738.092529,710.322937 743.000000,714.500000  "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "line-409",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1164.000000,580.000000   C1165.146973,584.828796 1162.396240,588.893188 1160.762817,592.903381   C1159.406372,596.233948 1159.108887,601.010315 1154.027222,602.124390   C1152.736328,602.407349 1152.040039,604.353333 1152.000000,606.000000  "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "line-410",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M810.500000,432.000000   C816.291260,437.463013 822.740784,442.114136 829.000000,447.000000  "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "line-411",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M830.500000,715.000000   C825.666199,714.673645 820.707825,712.763733 816.068176,714.217590   C813.039795,715.166626 810.666687,714.776306 808.000000,714.000000  "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "line-412",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1176.500000,664.000000   C1176.717285,668.955261 1174.317993,673.506775 1174.309326,678.499695   C1174.306763,680.010193 1174.497070,681.208679 1175.000000,682.500000  "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "line-413",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M900.500000,484.000000   C903.911804,488.164154 908.995911,489.640839 913.539978,491.920349   C915.367676,492.837219 917.116272,493.540985 918.000000,495.500000  "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "line-414",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1000.000000,594.500000   C1000.833313,594.500000 1001.685547,594.615051 1002.497009,594.481873   C1009.215271,593.379822 1014.169067,595.628723 1017.000000,602.000000  "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "line-415",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1043.500000,491.000000   C1037.722046,491.866028 1032.681274,489.534760 1027.462646,487.600769   C1024.689575,486.573029 1021.580811,485.711884 1018.500000,487.000000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-416",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 1105.2848,657.32949 c 0.4594,-5.89259 14.1697,45.45675 9.7259,27.66532 -1.1242,-4.50114 0.3662,1.77706 3.4579,5.33468",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "line-417",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1093.500000,582.500000   C1095.818848,588.816467 1101.389282,592.261108 1106.040405,596.455139   C1110.747803,600.699707 1116.383789,604.324036 1122.115967,606.132385   C1128.963501,608.292419 1135.948608,612.144531 1144.081787,608.692627   C1151.065674,605.728455 1158.938599,606.475891 1166.500000,606.500000  "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "line-418",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M802.000000,510.000000   C801.500000,510.666687 801.094421,511.439087 800.485046,511.983215   C795.622253,516.325439 789.419128,518.592041 784.336243,522.802246   C779.603027,526.722839 773.350769,524.965942 768.064636,522.839355   C765.522949,521.816895 763.666687,521.976196 761.500000,523.000000  "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "line-419",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M694.000000,389.500000   C691.856873,391.345093 690.838806,393.752747 690.349426,396.944489   C698.179260,399.795166 702.755615,407.020630 709.500000,411.500000  "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "line-420",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M742.000000,290.000000   C738.762024,295.666809 733.260193,298.690552 728.009644,302.015198   C727.627502,302.257111 727.382935,302.716248 726.902283,303.273987   C729.667297,309.911896 735.061523,315.245087 738.000000,322.000000  "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "line-421",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1204.000000,612.000000   C1199.879028,617.138611 1195.564575,622.194336 1196.500000,629.500000  "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "line-422",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1185.000122,201.499985   C1186.333374,207.333313 1187.666748,213.166656 1189.000122,218.999985  "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "line-423",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M940.000000,486.000000   C937.039856,490.086365 931.911743,490.163818 927.975159,492.457367   C926.398926,493.375732 924.232849,493.349274 923.500000,495.500000  "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "line-424",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M875.000000,337.500000   C876.707275,340.827515 876.577881,344.433716 876.467468,347.998993   C876.392456,350.420288 876.618042,352.745056 877.500000,355.000000  "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "line-425",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1042.000000,715.500000   C1044.164185,717.815063 1047.033936,718.357361 1049.972168,719.108704   C1052.908325,719.859497 1056.818970,719.358826 1058.000000,723.500000  "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "line-426",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M877.000000,625.500000   C872.833313,630.000000 868.643188,634.478577 864.515625,639.014221   C863.403687,640.236084 862.127808,640.922302 860.500000,641.000000  "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "line-427",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M607.500000,444.000000   C612.978027,447.020477 616.634399,452.319611 621.957092,455.570282   C622.956360,456.180542 623.972168,456.555695 625.000000,457.000000  "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "line-429",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M883.000000,774.000000   C885.431519,780.858276 885.493347,781.290344 891.980347,780.362427   C897.103271,779.629639 901.976379,781.033386 907.000183,781.030273   C912.205078,781.027039 915.774170,779.676025 918.500000,775.500000  "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "line-430",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1079.500000,577.000000   C1074.634277,579.014343 1071.973145,583.471558 1068.553345,587.051025   C1066.917969,588.762756 1065.507935,590.674622 1063.500000,592.000000  "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "line-431",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1002.000000,286.000000   C1007.790161,288.186462 1011.101379,293.188354 1014.972473,297.524567   C1016.474609,299.207214 1017.666687,301.166687 1019.000000,303.000000  "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "line-432",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M772.000000,541.500000   C777.000000,547.333313 782.000000,553.166626 787.000000,559.000000  "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "line-433",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1060.000000,666.000000   C1060.155640,670.762695 1056.794800,674.257202 1055.315308,678.434631   C1054.705566,680.156433 1055.148438,681.497986 1055.000000,683.000000  "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "line-434",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1165.500000,559.000000   C1167.477905,562.288879 1166.913330,565.935242 1167.019043,569.499451   C1167.083252,571.669128 1167.333252,573.833313 1167.500000,576.000000  "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "line-435",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M759.500000,320.000000   C753.337463,316.452026 747.766418,317.931061 742.500000,322.000000  "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "line-436",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M867.500000,676.500000   C869.892700,674.724182 871.968018,674.768127 875.089111,675.702148   C879.160583,676.920593 883.795227,676.497742 888.000000,678.000000  "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "line-437",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M770.500000,678.000000   C775.108276,684.466919 770.410278,689.819275 767.815247,694.905762   C764.859680,700.698792 759.851013,705.141724 754.518005,709.024719   C752.892273,710.208496 750.772583,711.057129 750.500000,713.500000  "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "line-438",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M728.000000,438.500000   C731.153870,440.855408 729.584473,444.522614 730.420044,447.522278   C731.173401,450.226776 731.044922,453.183899 733.000000,455.500000  "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "line-439",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1106.500000,686.000000   C1102.445557,683.790466 1098.776978,686.419617 1095.026733,687.139160   C1093.130859,687.502930 1091.340210,687.408325 1089.500000,687.500000  "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "line-440",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1190.000000,574.500000   C1190.666626,575.500000 1191.903320,576.497375 1191.907837,577.500427   C1191.938721,584.222900 1197.302246,589.562622 1196.599731,596.510071   C1196.372070,598.761719 1198.914917,600.126892 1199.969727,602.016907   C1202.611084,606.749878 1205.405151,611.344910 1209.500000,615.000000  "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "line-441",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M912.000000,711.500000   C916.333313,713.333374 920.619019,715.295227 925.026917,716.927246   C926.483826,717.466614 927.991150,717.684326 929.000000,719.000000  "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "line-442",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1035.750000,492.000000   C1031.567993,497.339630 1025.620361,499.810181 1019.500000,502.000000  "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "line-443",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M970.000000,468.500000   C961.946777,467.000427 955.365662,462.091461 948.034058,458.921265   C943.969604,457.163818 938.987305,456.253235 937.884766,450.522156   C937.612061,449.104645 935.594604,448.952972 933.999817,448.960236   C932.250610,448.968231 930.500000,448.666656 928.750000,448.500000  "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "line-444",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1078.500000,568.000000   C1078.093994,563.370239 1075.902222,560.736938 1071.027100,559.850830   C1068.211182,559.339050 1065.596436,557.454224 1063.022827,555.960571   C1061.073486,554.829163 1059.242554,553.878357 1057.000000,555.000000  "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "line-445",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M1082.000000,570.000000   C1089.314697,566.648010 1091.233398,559.328491 1094.695557,553.162964   C1091.083252,550.153442 1088.593018,550.236328 1085.517212,553.516113   C1082.933472,556.270996 1080.500000,559.166687 1078.000000,562.000000  "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "line-446",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1206.000000,214.500000   C1200.047485,214.340866 1195.115601,217.847977 1189.529175,219.127182   C1183.447266,220.519821 1178.607666,224.876083 1172.998779,227.497513   C1171.688110,228.110092 1170.446167,228.760666 1170.500000,230.500000  "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "line-447",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M994.000000,654.000000   C990.000000,655.666687 985.953918,657.233521 982.022095,659.047852   C980.389099,659.801270 979.000000,660.041626 977.500000,659.000000  "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "line-448",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M759.500000,541.500000   C760.664124,547.000000 759.478577,552.500000 759.500000,558.000000  "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "line-449",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M943.500000,485.500000   C944.776306,490.798645 942.835327,496.151703 943.881042,501.523163   C944.406006,504.219513 945.106262,506.780304 947.063782,508.424042   C950.984131,511.715942 950.535400,515.432983 949.000000,519.500000  "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "line-450",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M847.500000,665.000000   C850.054443,667.828369 853.183594,669.077209 857.002014,668.513611   C857.654480,668.417297 858.405029,668.310364 858.988342,668.530884   C862.702393,669.934998 863.374329,674.644836 867.167786,676.200500   C867.681519,676.411133 867.049866,679.332458 867.006714,681.000183   C866.907288,684.843628 866.583679,688.675354 867.455811,692.510071   C868.071045,695.214844 864.796143,697.578674 866.500000,700.500000  "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "line-451",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1010.500000,512.000000   C1004.365417,512.501892 999.744812,516.493591 994.561340,519.121033   C993.147949,519.837524 993.412720,522.322632 992.875427,523.959106   C992.004822,526.610962 990.333252,528.999939 988.999939,531.499939  "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "line-452",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1040.500000,504.000000   C1034.785767,503.821716 1029.455444,505.754913 1024.000000,507.000000  "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "line-453",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1042.500000,694.500000   C1043.430908,699.347412 1039.693604,702.106201 1037.441040,705.460388   C1036.135132,707.405029 1033.901611,708.677063 1033.000000,711.000000  "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "line-454",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1135.000000,610.500000   C1130.526245,615.114380 1125.453735,618.720398 1119.000000,620.000000  "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "line-455",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M768.500000,535.000000   C770.315063,537.835388 772.455383,540.054138 769.752625,544.166077   C767.792053,547.148865 768.036194,551.651062 767.574158,555.508911   C767.422241,556.777283 766.582458,557.216125 766.000000,558.000000  "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "line-456",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M905.000000,231.500000   C905.261169,234.921280 902.794189,237.219238 901.499512,239.999771   C900.334900,242.500732 899.166626,244.999985 898.000000,247.499985  "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "line-457",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1001.000000,287.000000   C996.666687,292.333313 992.333313,297.666656 988.000000,303.000000  "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "line-459",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M669.000000,384.000000   C674.662903,390.274933 682.862671,391.917389 690.000000,395.500000  "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "line-460",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M934.000000,723.500000   C944.517395,723.059265 951.304749,729.929382 958.500000,736.000000  "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "line-461",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M923.500000,224.000015   C922.666687,224.833344 920.978760,226.174362 921.127319,226.424393   C923.622864,230.625046 919.946777,234.094635 919.827148,237.994705   C919.677551,242.872437 917.183594,247.212952 914.000000,251.000000  "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "line-462",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1113.500000,144.500000   C1114.833374,146.166656 1115.957520,148.074203 1117.542969,149.450470   C1120.975708,152.430161 1122.118774,156.171127 1122.000000,160.500000  "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "line-463",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1308.500000,449.750000   C1307.473755,454.972717 1308.233887,460.252136 1308.000000,465.500000  "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "line-464",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M797.000000,412.500000   C791.669373,415.714142 787.350281,419.721283 784.311035,425.398865   C782.922119,427.993591 779.772217,430.105377 776.944702,431.376984   C770.601318,434.229614 767.518677,439.396210 765.546753,445.515076   C764.608215,448.427460 764.166626,451.500000 763.500000,454.500000  "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "line-465",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M788.500000,395.000000   C783.360168,398.505188 780.770386,403.593140 779.500000,409.500000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-466",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 1092.5493,638.44012 c 2.5873,4.0141 10.1199,14.06512 12.5517,17.83801",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "line-467",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M709.500000,417.000000   C706.180115,420.505371 705.860596,425.256012 704.638306,429.539459   C703.824158,432.392548 702.691101,434.393311 700.000000,435.500000  "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "line-468",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M991.500000,676.000000   C986.620605,674.514465 982.050415,673.291077 977.375183,677.356445   C974.734253,679.652710 970.833313,680.500000 967.500000,682.000000  "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "line-470",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1086.500000,689.500000   C1083.342651,689.155579 1080.180908,689.510559 1076.980103,689.215088   C1073.323853,688.877563 1070.536987,692.408447 1067.019653,693.560059   C1064.859131,694.267395 1063.025024,695.945435 1060.498779,695.507141   C1055.618530,694.660339 1049.754639,693.858948 1046.927856,690.625854   C1044.653809,688.025085 1042.275879,684.921143 1040.000000,682.000000  "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "line-471",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1121.500000,161.500000   C1122.365234,166.783096 1120.629150,171.632629 1119.000000,176.500000  "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "line-472",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1152.000000,623.500000   C1153.892822,631.051514 1155.009033,638.642273 1154.599243,646.505188   C1154.328613,651.697937 1156.683105,656.420166 1159.000000,661.000000  "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "line-473",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M861.000000,621.000000   C858.828369,627.217896 855.903442,633.391235 859.755127,639.997009   C860.771667,641.740417 860.221069,643.638245 859.411804,644.945374   C856.775696,649.203125 858.101990,652.989380 860.578613,656.443665   C862.276917,658.812500 861.619995,661.682251 863.000000,664.000000  "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "line-474",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1172.500000,601.500000   C1171.154785,598.194275 1168.944580,597.302795 1165.472290,598.413330   C1163.458374,599.057373 1161.166626,598.833313 1159.000000,599.000000  "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "line-475",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M815.000000,375.500000   C817.277039,377.373230 816.976257,379.967499 817.015991,382.499756   C817.056458,385.078308 816.410095,387.817993 818.500000,390.000000  "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "line-476",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1171.500000,604.000000   C1169.339478,603.644409 1167.537231,605.652222 1167.193604,606.572266   C1164.795288,612.995483 1158.648804,615.161377 1154.000000,619.000000  "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "line-477",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M682.500000,338.000000   C684.312317,341.835968 685.500793,345.629730 684.125427,350.039124   C683.512024,352.005798 682.963440,354.234711 684.825073,356.635651   C686.452515,358.734497 685.785522,361.646851 683.039795,363.557190   C681.325867,364.749695 679.788757,366.344696 678.546509,368.034210   C676.348145,371.023773 673.501221,371.955414 670.000000,371.500000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-478",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m 1206.2864,228.71693 c -1.0856,4.71534 -1.4838,9.25556 -3.7864,13.28307",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "line-479",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M995.500000,662.000000   C989.181702,663.758728 986.075256,668.863098 983.000000,674.000000  "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "line-480",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1200.500000,542.000000   C1197.070312,540.391846 1195.250732,543.875244 1192.533203,544.620911   C1188.876221,545.624329 1188.802979,548.585327 1189.388428,552.019043   C1190.026001,555.758057 1189.467773,559.719421 1192.000000,563.000000  "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "line-481",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M732.000000,721.000000   C724.013062,720.475342 716.880798,723.796997 709.500000,726.000000  "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "line-482",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M946.500000,270.500000   C942.140930,266.589905 937.868286,262.722321 932.619568,259.786255   C928.996948,257.759888 926.744568,257.405334 923.435120,259.914398   C919.702026,262.744720 915.965698,265.869965 911.000000,266.500000  "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "line-483",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M953.000000,522.500000   C958.356140,522.578369 962.738586,525.135132 967.000000,528.000000  "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "line-484",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M745.000000,417.000000   C741.713501,421.666840 738.531128,426.452057 732.500000,428.000000  "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "line-485",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M605.000000,676.500000   C600.846985,680.305908 598.071655,685.081299 595.500000,690.000000  "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "line-486",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M970.000000,473.500000   C971.597290,475.831482 970.910889,478.476624 970.974731,481.000641   C971.032654,483.293793 970.905090,485.585999 972.500000,487.500000  "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "line-487",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1063.500000,699.000000   C1067.548584,702.851379 1073.384033,703.714050 1077.582642,707.406006   C1078.334595,708.067200 1080.166626,707.500000 1081.500000,707.500000  "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "line-488",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1159.000000,674.500000   C1161.283447,676.290405 1162.429932,679.089783 1162.819458,681.528809   C1163.647461,686.711670 1166.651611,689.512024 1171.000000,691.500000  "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "line-489",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M894.500000,676.000000   C896.846130,677.487549 899.471619,676.974365 902.000000,676.972839   C904.411133,676.971375 906.764771,676.931152 908.500000,679.000000  "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "line-490",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M884.999939,623.500000   C885.666626,625.000000 886.111572,626.661865 887.057739,627.957825   C888.163269,629.471863 888.300537,630.618042 887.010864,632.010010   C884.266785,634.971741 882.874207,638.865356 878.083984,640.283691   C874.492004,641.347168 870.891174,644.466309 868.706055,647.641785   C866.248840,651.212585 863.252014,652.397217 859.500000,653.000000  "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "line-491",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M991.500000,335.000000   C988.833313,336.365875 986.183472,335.298523 983.494446,335.063904   C981.521851,334.891815 979.438782,334.599060 977.500000,335.500000  "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "line-492",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1015.000000,707.000000   C1018.086304,711.426880 1019.105469,717.034973 1023.000000,721.000000  "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "line-493",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1077.500000,708.000000   C1076.296265,710.622192 1073.594849,711.452271 1071.491699,712.988647   C1069.365234,714.542175 1066.739136,715.679382 1067.000000,719.000000  "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "line-494",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M945.000000,820.500000   C940.379089,819.201172 935.949402,820.483521 931.500000,821.500000  "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "line-495",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M697.000000,581.500000   C699.893311,585.545715 699.033813,590.981323 702.000000,595.000000  "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "line-496",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1152.500000,567.000000   C1154.756836,571.264404 1152.161621,576.247681 1154.500000,580.500000  "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "line-497",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1195.000000,588.500000   C1191.894043,588.990173 1190.137451,591.741455 1187.491089,592.980957   C1185.580444,593.875916 1184.044800,595.967834 1181.500000,595.000000  "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "line-498",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1061.000000,534.500000   C1057.562622,538.359070 1057.119995,544.060974 1053.000000,547.500000  "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "line-499",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1051.000000,554.500000   C1048.333374,558.833313 1045.666626,563.166687 1043.000000,567.500000  "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "line-500",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M866.500000,329.500000   C864.208618,328.045319 861.999390,329.548828 860.050171,330.160034   C857.764038,330.876923 855.727112,331.119110 853.500000,330.500000  "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "line-501",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M984.000000,509.500000   C980.169128,513.169250 978.091187,518.671082 972.500000,520.500000  "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "line-502",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M954.500000,442.000000   C948.088989,442.812866 940.992859,442.072693 937.500000,449.500000  "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "line-503",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M903.000000,504.500000   C904.667969,506.580444 907.148926,506.920990 909.503113,507.487152   C911.757446,508.029327 914.001709,508.521149 915.000000,511.000000  "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "line-504",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 1064.8162,591.2914 c -2.5,2.33332 -9.3973,9.29594 -11.7876,11.73661 -1.5732,1.60639 -3.2481,2.79187 -5.5286,2.97199"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "line-505",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M829.000000,656.000000   C831.230408,661.359497 837.022156,661.970398 841.000000,665.000000  "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "line-506",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M914.500000,253.500000   C912.793762,257.718597 910.463989,261.635773 910.390747,266.498352   C910.322510,271.024628 900.975525,276.766113 897.018066,274.960388   C891.642822,272.507721 887.121887,273.048492 883.500000,278.000000  "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "line-507",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1309.000000,486.000000   C1308.000000,486.833344 1306.814697,487.521606 1306.030029,488.523529   C1300.853271,495.133728 1294.180298,499.871613 1287.000000,504.000000  "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "line-508",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1189.000000,238.000000   C1188.001953,242.333786 1188.664673,247.050812 1186.000000,251.000000  "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "line-509",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M626.000000,534.500000   C622.545837,530.151794 618.304504,526.740662 613.500000,524.000000  "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "line-510",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1012.500000,457.500000   C1008.695862,458.124695 1006.776245,461.446930 1004.069519,463.587860   C1002.480225,464.844940 1002.727417,467.086395 1003.502258,468.999084   C1004.997437,472.690094 1006.217041,476.426025 1005.500000,480.500000  "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "line-511",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1189.500000,223.000000   C1188.164551,227.236923 1190.057617,231.846390 1188.000000,236.000000  "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "line-512",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1120.500000,587.000000   C1118.775146,592.262390 1113.641113,594.933960 1111.000000,599.500000  "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "line-513",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1025.000000,725.000000   C1028.000000,729.166687 1031.000000,733.333313 1034.000000,737.500000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-514",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 946.18379,480.86094 c 3.17456,4.10492 18.24562,8.88351 21.91719,12.10097",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "line-515",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M997.500000,597.500000   C998.884399,600.035278 999.569214,602.677917 998.484436,605.494019   C997.893738,607.027527 997.822327,608.500000 998.500000,610.000000  "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "line-516",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M861.000000,704.500000   C862.817017,708.547974 860.590149,712.919434 862.000000,717.000000  "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "line-517",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1163.500000,663.000000   C1167.784790,665.222839 1174.880859,664.969421 1177.500000,662.500000   C1180.446289,659.722107 1180.815796,655.103577 1178.500000,650.000000  "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "line-518",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1010.000000,621.000000   C1006.590698,621.653809 1005.515320,624.826416 1003.472412,626.973755   C1002.259277,628.248962 1001.304443,629.871704 999.500000,630.500000  "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "line-519",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1034.000000,719.000000   C1035.969360,724.257874 1040.938721,727.115723 1044.000000,731.500000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-520",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 1083.6457,622.36094 c 2.9814,3.80371 7.6882,11.09878 9.3543,15.63906",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "line-521",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M906.000000,251.500000   C904.323364,255.237869 900.786072,257.008942 897.433472,258.331299   C894.482971,259.495087 892.403870,261.104553 890.451721,263.459991   C886.813538,267.849823 880.743896,268.470337 876.500000,272.000000  "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "line-522",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1012.500000,449.000000   C1007.587524,449.464386 1003.866882,452.745911 999.206238,454.557983   C1000.090271,457.814972 1002.338379,460.252228 1004.000000,463.000000  "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "line-523",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M927.000000,341.000000   C930.577881,344.586639 936.112183,345.116394 939.500000,349.000000  "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "line-524",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M992.500000,476.000000   C995.150940,478.558167 998.359863,479.663879 1001.993042,480.063385   C1004.236206,480.310089 1006.591553,480.816925 1008.000000,483.000000  "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "line-525",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M820.000000,323.500000   C815.203613,326.145386 813.653748,331.965179 809.000000,334.750000  "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "line-526",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M750.000000,691.500000   C751.740784,696.718201 756.773926,699.073364 760.000000,703.000000  "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "line-527",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M867.000000,469.000000   C870.963074,470.937134 875.197449,472.394257 878.500000,475.500000  "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "line-528",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M775.500000,313.000000   C778.778015,316.499268 783.568359,315.461578 787.500000,317.000000  "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "line-529",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M867.500000,781.500000   C868.287170,787.554504 862.985779,789.803589 860.000000,793.500000  "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "line-530",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1063.500000,503.000000   C1059.475342,502.573578 1055.429688,501.644775 1051.500000,503.500000  "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "line-531",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M979.000000,594.500000   C981.432068,600.784912 986.075928,606.559387 983.500000,614.000000  "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "line-532",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M874.500000,711.000000   C866.044556,711.498291 858.250305,719.292480 858.000000,727.500000  "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "line-533",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M719.000000,466.500000   C716.500000,468.833344 714.003418,471.170319 711.498474,473.498383   C710.328918,474.585358 709.251770,475.709229 709.500000,477.500000  "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "line-534",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1209.000000,510.500000   C1204.204102,510.963562 1201.435669,515.014404 1197.500000,517.000000  "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "line-535",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M788.500000,307.000000   C784.467041,306.518768 781.256714,310.767914 777.000000,309.000000  "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "line-536",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m 851,428.25 c 5.5946,3.19583 12.02692,2.36502 18.01227,3.69467 1.80658,0.40137 56.4111,14.65704 58.06705,15.96588"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "line-537",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1242.000000,598.000000   C1239.832886,597.831482 1237.829956,598.339172 1236.002319,599.503662   C1234.318848,600.576355 1232.750610,602.030029 1230.500000,601.000000  "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "line-538",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M733.500000,459.000000   C728.494324,458.753021 725.370117,462.112213 722.000000,465.000000  "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "line-539",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1042.500000,664.000000   C1041.149048,669.234802 1035.250244,670.541870 1032.995361,674.982056   C1033.718750,677.695068 1036.296753,678.699890 1038.000000,680.500000  "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "line-540",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M765.500000,790.000000   C768.908325,792.563171 772.926819,793.121460 777.000000,793.500000  "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "line-541",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M973.000000,497.500000   C978.601440,498.135254 980.493469,503.304260 984.000000,506.500000  "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "line-542",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1128.000000,519.000000   C1131.309082,522.303955 1136.376831,522.911194 1139.500000,526.500000  "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "line-543",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M795.500000,784.000000   C793.213135,788.046448 788.047119,789.026672 785.775452,793.382874   C785.038879,794.795288 781.666626,794.833313 779.500000,795.499939  "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "line-544",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M683.000000,354.000000   C680.681519,354.775757 679.372803,356.614136 677.948730,358.460449   C676.637085,360.161011 675.134338,361.968536 672.500000,361.500000  "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "line-545",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9,
    d: " M1039.000000,381.500000   C1035.392944,376.776398 1032.099854,371.977631 1033.322754,365.466705   C1033.385620,365.132141 1033.801636,363.234680 1032.052368,362.391327   C1028.700439,360.775177 1026.034668,357.764099 1022.000000,357.500000  "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "line-546",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M889.000000,482.000000   C888.057434,476.984589 882.495728,478.364899 880.090515,474.955536   C876.197083,478.508881 870.983643,479.884583 869.000000,485.000000  "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "line-547",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1025.000000,700.500000   C1025.574585,704.944153 1028.319214,708.204651 1031.000000,711.500000  "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "line-548",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M990.000000,518.500000   C986.115845,519.898376 982.169250,521.171875 979.000000,524.000000  "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "line-549",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M816.500000,395.000000   C818.755005,400.968079 823.239929,406.130951 823.000000,413.000000  "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "line-550",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1025.500000,666.500000   C1026.767822,670.020691 1030.637939,671.551453 1032.144775,675.401855   C1028.506592,677.605652 1026.463623,682.490479 1021.000000,682.000000  "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "line-551",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M996.500000,412.500000   C992.678772,413.867065 989.311401,410.241333 985.500000,411.500000  "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "line-552",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M877.000000,651.500000   C876.360657,655.493835 876.410339,659.399048 873.731750,663.164856   C871.585205,666.182617 871.500000,670.666687 870.500000,674.500000  "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "line-553",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1254.500000,258.000000   C1251.662354,261.164520 1251.631348,265.732361 1249.000000,269.000000  "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "line-554",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1114.500000,682.500000   C1119.741333,678.217957 1125.572144,678.946899 1131.500000,680.500000  "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "line-555",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1150.500000,608.000000   C1151.250000,611.000000 1151.971802,614.007385 1152.758057,616.997864   C1153.521240,619.900757 1154.050293,622.434998 1150.023315,623.581909   C1146.892334,624.473572 1145.015503,628.451660 1141.000000,627.500000  "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "line-556",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M788.500000,379.000000   C789.823120,382.220032 790.232300,385.796967 789.566711,388.961456   C788.735291,392.914246 789.872253,396.326904 790.388062,400.015656   C791.057617,404.804260 793.211914,407.685547 798.000000,408.500000  "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "line-557",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1018.500000,668.500000   C1011.849670,668.327698 1005.265381,668.468872 999.500000,672.500000  "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "line-558",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: " M1159.500000,556.000000   C1158.500000,557.833313 1157.667480,559.785034 1156.470337,561.479004   C1151.939453,567.889832 1151.895142,567.858521 1144.500000,564.500000  "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "line-559",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1046.500000,500.000000   C1050.182739,501.878174 1051.818237,505.168060 1052.462646,509.006287   C1052.817139,511.117096 1053.837402,512.816345 1055.000000,514.500000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-560",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M957.000000,360.500000   C954.369324,363.540955 954.344666,367.822845 952.000000,371.000000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "line-561",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M967.000000,746.500000   C968.666687,750.000000 970.333374,753.500000 972.000000,757.000000  "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "line-562",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1010.500000,214.500000   C1010.614441,216.941223 1008.631409,218.295380 1007.416138,219.937958   C1006.240784,221.526489 1004.877197,222.855270 1005.000000,225.000000  "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "line-563",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1219.000000,210.000000   C1216.015503,212.804428 1211.755737,211.145050 1208.500000,213.000000  "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "line-564",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1015.500000,659.000000   C1012.985291,662.294678 1008.000488,663.509155 1007.500000,668.500000  "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "line-565",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M933.000000,661.500000   C935.110229,664.989502 938.350769,667.687805 940.000000,671.500000  "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "line-566",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M894.000000,259.000000   C894.056274,253.569153 894.619446,251.799286 897.500000,248.000031   C902.566589,248.433716 906.981873,252.775314 912.500000,250.500000   C915.496582,254.950180 922.103821,253.382492 925.000000,258.000000  "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "line-567",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1167.500000,501.500000   C1170.104248,501.708954 1172.498047,500.588043 1175.005493,500.296844   C1179.911255,499.726990 1183.844360,502.071716 1187.500000,505.000000  "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "line-568",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M991.000000,278.500000   C993.621277,281.762177 998.056519,282.233582 1001.000000,285.000000  "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "line-569",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M990.000000,643.500000   C992.165161,645.534058 992.472534,648.434875 993.500549,650.999756   C995.128296,655.061279 997.274048,655.758606 1000.463745,652.958679   C1002.490784,651.179382 1004.166687,649.000061 1006.000061,647.000061  "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "line-570",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M768.000000,572.000000   C770.877380,574.806885 770.303284,579.684692 774.000000,582.000000  "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "line-571",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1020.500000,640.500000   C1016.607666,641.316956 1013.121704,642.872864 1010.500000,646.000000  "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "line-572",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1246.500000,513.750000   C1244.993530,510.346558 1243.505615,506.931030 1240.500000,504.500000  "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "line-573",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M727.000000,474.000000   C726.575134,470.151978 722.864014,467.890076 720.716431,466.412079   C717.218811,464.005188 714.613586,460.626312 711.000000,458.500000  "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "line-574",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M874.000000,323.000000   C866.982544,326.390533 865.751160,332.586426 866.000000,339.500000  "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "line-575",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M873.000000,662.500000   C868.179016,663.443359 862.421753,662.358215 860.000000,668.500000  "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "line-576",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M989.500000,210.500000   C989.688721,204.313263 992.471497,199.283493 996.504944,199.131012   C999.981079,198.999603 1003.502563,199.984024 1006.993835,200.538879   C1007.208069,200.572922 1007.390381,201.153946 1007.468994,201.506897   C1007.496521,201.630295 1007.166687,201.833344 1007.000000,202.000000  "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "line-577",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1091.000000,709.500000   C1093.399658,712.619385 1097.996338,711.100403 1100.500000,714.000000  "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "line-578",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M967.500000,688.000000   C969.942139,690.615723 974.356018,689.287903 976.500000,692.500000  "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "line-579",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M867.500000,650.500000   C870.611328,651.718384 874.203735,651.693176 876.919739,650.765076   C881.562927,649.178467 880.458252,644.375000 880.500000,640.500000  "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "line-580",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M755.500000,519.000000   C761.202637,521.786865 762.431274,528.053467 766.000000,532.500000  "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    id: "line-581",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M993.500000,316.000000   C990.890381,318.527740 986.955139,318.980499 984.500000,321.750000  "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    id: "line-582",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M986.000000,509.500000   C987.166626,511.500000 988.544128,513.410828 989.438904,515.525879   C990.280518,517.515503 991.671265,518.662109 993.500000,519.500000  "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    id: "line-583",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M943.000000,672.500000   C944.983582,675.849792 948.406555,677.760071 951.000000,680.500000  "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    id: "line-584",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M1010.000000,648.500000   C1012.333313,651.000000 1014.666626,653.500000 1017.000000,656.000000  "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    id: "line-585",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M1001.000000,634.500000   C1003.849487,637.241882 1006.093811,640.306091 1005.984680,644.499573   C1005.927185,646.707886 1007.524353,646.737427 1009.000000,647.000000  "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    id: "line-586",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M 988,302.68379 994,314.5"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    id: "line-587",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: " M1181.000000,687.500000   C1180.995239,689.717224 1181.262085,691.976196 1180.000000,694.000000  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "line-64",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 1159.8477,321.68379 c -4.3877,-4.23816 -17.4516,2.70354 -21.8075,3.52816 -26.7903,5.07165 -62.9614,24.55488 -84.3071,41.84379 -4.5476,3.68344 -27.8343,-8.16898 -33.839,-7.33387",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-329",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M958.500000,271.500000   C959.833313,274.666687 961.271301,277.794495 962.466125,281.012573   C963.383118,283.482544 965.645020,283.683258 967.510925,283.910461   C972.497925,284.517761 974.912109,287.197144 976.110046,291.972382   C977.064270,295.775970 978.603516,299.579498 980.663940,302.898224   C981.725586,304.608398 981.563049,305.964691 981.451782,307.496490   C981.329651,309.178497 980.299683,310.934692 980.593567,312.482239   C981.783936,318.749878 978.312622,322.332214 974.113770,326.125916   C971.345642,328.626953 969.321716,332.154785 967.571228,335.536865   C963.838257,342.749634 960.500000,350.166656 957.000000,357.500000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1,
      strokeWidth: 4,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-201",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 947.86094,405.57617 c 3.76733,6.51416 7.28554,19.63559 7.65084,26.88516 0.17645,3.49973 -4.47901,26.66148 -3.43561,30.11973",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-1",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m 1284.3483,588.87391 c 10.642,7.01619 20.3942,2.7615 29.4809,-2.07734 15.0178,-7.99729 28.0045,-18.07781 41.3105,-27.79517 15.6322,-11.41616 31.0348,-23.04322 46.8935,-34.24884 5.155,-3.64253 11.1967,-6.65321 17.782,-8.49443 6.6876,-1.86984 12.0571,-0.0835 15.9634,4.93192 3.421,4.39213 4.8103,9.42042 5.4664,14.43274 1.9074,14.57795 3.1032,29.21848 5.1561,43.78124 0.8061,5.71822 2.3659,11.54454 4.974,16.87682 3.7753,7.7184 12.3416,10.02176 21.9742,10.55548 7.8804,0.43669 15.5587,-1.2296 23.3991,-1.0554 14.3273,0.3185 26.8346,4.02179 37.6174,11.90594 10.8836,7.95798 20.2082,17.31424 32.5722,23.94108 12.7511,6.83445 26.5293,11.29573 41.8429,13.03718 24.7566,2.81516 49.6221,3.14897 74.5074,2.81746 19.7089,-0.2626 39.4227,-0.99884 59.097,-2.00169 12.1088,-0.6172 24.1858,-1.54963 36.3237,-2.015 12.3437,-0.47332 24.6328,-1.87561 36.9458,-2.87111",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-458",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: " M1196.000000,630.500000   C1193.803589,633.451233 1191.382690,636.123535 1188.560669,638.570007   C1180.718994,645.368103 1173.038818,652.367126 1165.559814,659.562073   C1162.346313,662.653503 1158.326660,665.034973 1156.436890,669.473145   C1155.397339,671.914551 1152.547485,672.174561 1150.516235,671.885559   C1141.345581,670.580750 1136.040894,675.790833 1131.546875,682.531250   C1131.100220,683.201111 1130.899902,684.008606 1130.000488,683.982361   C1125.144165,683.840515 1122.721680,688.100830 1119.000000,690.000000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-263",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "m 1053.4686,581.53808 c 4.4174,4.93056 11.2353,12.90134 14.374,18.99663 -0.1488,1.91767 6.2234,3.60132 6.5746,6.35767",
    style: {
      stroke: "blue",
      strokeWidth: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-358",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: " M969.500000,493.000000   C969.666748,495.055481 971.927307,495.715118 972.100464,497.516785   C971.837769,506.702881 970.056091,515.947021 973.500671,524.999756   C974.986328,528.904480 977.541260,531.408691 981.997498,530.974121   C986.570312,530.528259 989.976868,531.933899 992.560669,535.961060   C995.749878,540.931824 1001.800049,541.391602 1006.500000,544.000000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-237",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m 1007.5052,543.0022 c -1.2419,2.97906 -0.082,4.1773 2.9623,5.10437 5.5724,1.69659 16.1204,9.4779 20.0753,13.85467 0.6983,0.77271 2.0871,0.87793 2.9366,1.56427 6.7169,5.42664 13.3907,10.90888 18.5206,17.97449",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-319",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m 1284.5,589 c -1.9435,-0.0351 -3.1708,-1.30798 -4.5139,-2.48407 -5.0372,-4.41034 -10.7173,-3.95587 -17.0103,-3.2243 -9.4135,1.09436 -13.5814,8.80505 -19.9758,13.70837 -0.248,7.82666 -6.6521,11.08313 -11.4923,15.50836 -0.8746,0.79962 -1.5546,1.56238 -3.0082,1.54981 -5.7267,-0.0496 -26.9047,14.12197 -32.5872,14.42855",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-399",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m 1025.5,200 c -3.5627,5.24213 -7.0367,10.58694 -13.017,13.4646 -0.8772,0.42204 -2.3135,0.86801 -2.9321,0.45851 -6.4219,-4.25154 -13.75335,-1.63187 -20.57031,-2.81078 -3.22919,-0.55844 -6.57617,1.82303 -7.24969,4.44693 -1.49445,5.82146 -5.93787,10.0404 -7.5163,15.50275 -0.90479,3.13101 -3.19659,5.47748 -3.89917,8.02498 -1.83673,6.65958 -14.81823,24.2571 -12.55547,31.79212",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-40",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 1177.8857,184.42383 c -5.1418,-1.80803 -17.3594,-7.54425 -24.3868,-5.90932 -5.2044,1.2108 -10.6615,-0.78191 -15.9996,-0.99753 -27.0028,-1.09083 -54.168,0.86354 -80.2435,7.29294 -2.6256,0.64735 -28.0031,15.92586 -30.0835,14.63872",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-306",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1179.000000,185.000000   C1185.919189,186.410126 1192.051636,189.858475 1198.538330,192.402328   C1205.772827,195.239502 1207.373169,200.571609 1207.052002,207.502411   C1206.740845,214.217484 1208.028564,221.069519 1205.000000,227.500000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-106",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m 1189,277.5 c -0.8672,6.51349 -5.0166,11.59924 -8.2117,16.8717 -4.2888,7.07706 -9.0749,13.97556 -14.7119,20.19754 -1.8702,2.0644 -3.7959,3.8913 -6.0686,5.44226",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-469",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: " M1203.000000,244.000000   C1200.752930,255.079117 1195.216064,264.957214 1191.500000,275.500000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-239",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 883.21523,401 c -6.31317,-0.48056 -11.24108,1.61633 -15.0946,6.93143 -2.67505,3.68972 -6.15723,6.81741 -9.41937,10.05447 -14.8338,14.71964 -29.50269,29.58521 -42.50696,45.99753 -1.68054,2.12103 -3.57391,4.08917 -5.50043,5.99502 -1.73199,1.71341 -2.19781,3.72626 -1.89331,6.46549 -5.73443,-2.36206 3.0647,3.94551 -1.35193,-0.0267",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-283",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.24954,
    d: "m 779.37521,502.12475 c -6.78623,3.03316 -3.44977,2.71776 -9.67499,6.55764 -2.86023,1.76432 -5.7895,4.13651 -8.74767,6.11192 -3.67261,2.45249 -12.50123,4.16122 -11.17042,7.12366",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-252",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: " M717.500000,543.000000   C705.333374,549.666687 693.072571,556.168640 681.027649,563.048401   C669.938904,569.381897 658.457336,574.926575 646.959839,580.415894   C637.943420,584.720642 628.961914,589.176636 619.500000,592.500000  ",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m 536.19942,496.00578 c -3.49255,-0.40497 -6.40546,1.28351 -9.51569,2.45856 -17.71661,6.69348 -42.31672,19.7285 -60.96265,23.58715",
    style: {
      display: "inline",
      fill: "none",
      stroke: "blue",
      strokeOpacity: 1
    },
    clipPath: "url(#clipPath64)",
    transform: "matrix(1.1232473,0,0,1.0453243,18.476871,74.941063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line-2",
    fill: "none",
    className: "hover-highlight",
    opacity: 1,
    stroke: "blue",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m 184,484.5 c 4.95633,5.66956 11.9227,8.50146 18.06811,12.39243 32.66051,20.6788 63.10502,44.39016 94.00113,67.51504 23.92679,17.90851 47.51297,36.35645 74.87525,49.21069 21.35919,10.03412 43.59372,15.77918 67.05337,17.4126 29.74259,2.07092 58.97681,-1.56299 87.98664,-7.60534 6.84399,-1.42554 27.2478,-6.4365 34.2489,-7.1721",
    style: {
      stroke: "blue",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathwayCleaner);
export default __webpack_public_path__ + "static/media/pathway-cleaner.e14e349d8be7c34acfaff5619cc1b0be.svg";
export { ForwardRef as ReactComponent };